(ns app.front.review-v2.view
  (:require [app.domain.acceptance.model :as acceptance-model]
            [app.domain.application.model :as app-model]
            [app.domain.attachment.model :as attachment-model]
            [app.domain.cloudcheck.model :as cloudcheck-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.plan-review-integration-model :as plan-review-integration-model]
            [app.domain.party.model :as party-model]
            [app.domain.review.model :as review-model]
            [app.domain.util :as du]
            [app.front.acceptance.subs :as acceptance-subs]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.form.add :as add-form]
            [app.front.form.subs :as form-subs]
            [app.front.process :as process]
            [app.front.requirement.events :as req-events]
            [app.front.requirement.subs :as req-subs]
            [app.front.review-v2.subs :as review-subs]
            [app.front.ui :as ui]
            [app.front.ui.blip :as ui-blip]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.contextual-menu :as ctx-menu]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.error-list :as ui-error-list]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.ui.status :as ui-status]
            [app.front.ui.table :as ui-table]
            [app.front.ui.text-button :as ui-text-button]
            [app.front.ui.v2.composed-card :as ui-card]
            [app.front.ui.v2.status-tag :as ui-status-tag]
            [app.front.util :as futil :refer [for-all for-frag]]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.attachment.modal :as attachment-modals]
            [app.front.view.attachment.subs :as attachment-subs]
            [app.front.view.attachment.upload :as att-upload]
            [app.front.view.party.subs :as party-subs]
            [app.front.view.party.subs-req :as party-req-subs]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.components :as components]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.string :as str-util]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]))


(def status-icons
  {:review.status/unreviewed        i/clock
   :review.status/in-review         i/search
   :review.status/changes-requested i/remove
   :review.status/approved          i/check
   :review.status/draft             i/file})


(def status-icon-colors
  {:review.status/changes-requested "var(--status-informative)"
   :review.status/approved          "var(--status-success)"})


(def status-indicator
  {:review.status/changes-requested :critical
   :review.status/approved          :ok
   :review.status/in-review         :warning})


(defn item-status-indicator [acceptance]
  (case (:acceptance/value acceptance)
    :acceptance.value/ok
    :ok

    :acceptance.value/needs-changes
    (if (du/in-state? :acceptance.state/active acceptance)
      :task
      :critical)

    :task))


(def request-status-indicator
  {:border-ui-red-100 :critical
   :border-ui-green   :ok})


(def comment-switcher-options
  [:review/comments-for-this-review :review/previous-comments])


(defn status-icon [status icon-description]
  (let [status-icon (get status-icons status)
        icon-color  (get status-icon-colors status)]
    (cc/icon
      (p/assoc-if
        {:icon        status-icon
         :description icon-description}
        :fill icon-color))))


(defn review-status [tr {:review/keys [status] :as review}]
  (let [final-review?    (and (ff/enabled? :feature-flag.id/final-review)
                              (review-model/final-review? review))
        review-id        (:db/id review)
        completion-stats (when (and final-review?
                                    (= status :review.status/unreviewed))
                           (<sub [::review-subs/final-review-completion-stats review-id]))
        final-ready?     (when final-review?
                           (<sub [::review-subs/final-review-ready? review-id]))
        awaiting-final?  (and (ff/enabled? :feature-flag.id/final-review)
                              (not final-review?)
                              (#{:review.status/approved :review.status/changes-requested} status)
                              (<sub [::review-subs/awaiting-final-review? review-id]))
        status-text      (cond
                           ;; Final Review with incomplete predecessors
                           (and final-review?
                                (= status :review.status/unreviewed)
                                (not final-ready?)
                                completion-stats)
                           (tr [:review/final-review-complete-preceding]
                               [(:completed completion-stats) (:total completion-stats)])

                           ;; Final Review ready to begin
                           (and final-review?
                                (= status :review.status/unreviewed)
                                final-ready?)
                           (tr [:review/final-review-ready-to-begin])

                           awaiting-final?
                           (str (tr [status]) " " (tr [:review/awaiting-final-review]))

                           ;; Normal status
                           :else
                           (tr [status]))]
    [:div.flex.flex-nowrap
     [:span.inline-block
      status-text]]))


(defn review-name [tr {:review/keys [review-config description status] :as review} reviews]
  (let [language             (<sub [:language])
        blocked-by-previous? (and (-> review :review/review-config :review.config/start-after-previous-finished?)
                                  (seq (review-model/previous-unfinished-application-reviews review reviews)))]
    [:div.flex.flex-col
     [:div.flex.flex-row
      (when (and blocked-by-previous?
                 (or (= status :review.status/unreviewed)
                     (= status :review.status/draft)))
        (cc/icon {:icon        i/dependency
                  :class-name  "mr-1 mr-2"
                  :height      "22px"
                  :description (tr [:review.config/start-after-previous-finished])}))
      [:span.block
       (review-model/review-config-name review-config language)]]
     [ui-rt/expandable-text
      {:rt-enabled? false
       :text        description
       :max-len     70
       :tr          tr}]]))

(defn get-review-status [acc]
  (if (and (= (:acceptance/value acc) :acceptance.value/needs-changes)
           (du/in-state? :acceptance.state/active acc))
    :review.status/unreviewed
    (or (:acceptance/value acc) :review.status/unreviewed)))


(defn review-time-used [{:review/keys [minutes-spent]}]
  (date-util/minutes-to-hour-and-minutes minutes-spent))


(defn review-headers [tr]
  [(tr [:review/review]) (tr [:review/status]) (tr [:review/latest-review-comment]) (tr [:review/reviewer]) (tr [:review/review-done])])

(defn- review-comment
  [tr review-id]
  [ui-rt/expandable-text
   {:rt-enabled? (ff/enabled? :feature-flag.id/rich-text-in-applicant-review-comments)
    :text        (<sub [::review-subs/latest-review-comment review-id])
    :max-len     90
    :tr          tr}])

(defn reviews-list-public [tr reviews]
  [components/structured-list-keyed
   {:wrapper-opts {:aria-label (tr [:reviews])}}
   (review-headers tr)
   (for-all [review reviews]
     ;; TODO get users from backend
     {:key   (:db/id review)
      :cells [(review-name tr review reviews)
              [review-status tr review]
              [review-comment tr (:db/id review)]
              [:span.whitespace-nowrap
               (if-some [assignee (:review/assignee review)]
                 (user-model/full-name assignee)
                 (tr [:review/unassigned]))]
              (when-let [end-date (:review/end review)]
                [:span.whitespace-nowrap [(<sub [::date-util/date-time-fn]) end-date]])]})])

(defn user-col [tr review]
  (if-some [assignee (:review/assignee review)]
    (user-model/full-name
      (if (integer? assignee)
        (<sub [::entities/entity assignee])
        assignee))
    (tr [:review/unassigned])))

(defn reviewer-col [tr review]
  (if (:review/assignee review)
    [user-col tr review]
    [:span (if (and (ff/enabled? :feature-flag.id/review-assignment-groups)
                    (review-model/not-yet-begun? review))
             (or (-> review :review/assigned-to-group :group/name)
                 (tr [:review/unassigned]))
             (tr [:review/unassigned]))]))

(defn- return-to-in-review-signal [review-id sub-review-id]
  [:process.signal/return-to-in-review (p/remove-vals nil? (util/mmap review-id sub-review-id))])

(defn- start-new-review-round-signal [review-id]
  [:process.signal/start-new-review-round (util/mmap review-id)])

(defn review-state-change-button [tr application-id signal button-text confirm-text icon & [{:keys [on-click]}]]
  (let [opts     {:class-name       "lg:w-min xl:w-auto"
                  :size             :small
                  :icon             icon
                  :data-cy          "review-primary-action"
                  :icon-description button-text
                  :disabled         (not (<sub [::process/app-signal-permitted? signal]))}
        on-click (or on-click #(>evt [::process/signal application-id signal]))]
    (if confirm-text
      [ui/modal-confirmation-button {:id                  (-> signal first name (str "-button"))
                                     :tr                  tr
                                     :on-yes-click        on-click
                                     :trigger-button-opts opts
                                     :trigger-button-text button-text}
       [:div confirm-text]]
      (cc/button
        (assoc opts :on-click on-click)
        button-text))))

(defn- complete-button-label-key [review review-result]
  (cond
    (review-model/final-review? review)
    :review/send-review-results

    (review-model/linked-to-incomplete-final-review? review)
    :review/send-to-final-review

    :else
    (case review-result
      :review.status/approved
      :review/approve

      :review.status/changes-requested
      :review/request-changes)))

(defn- request-change [review send-to-final-review? signal-opts]
  (cond
    (review-model/final-review? review)
    [[:process.signal/request-changes-for-final-review-and-change-state signal-opts]
     [:process.signal/request-changes-for-final-review signal-opts]]

    send-to-final-review?
    [[:process.signal/request-changes-to-final signal-opts]]

    :else
    [[:process.signal/request-changes-and-change-state signal-opts]
     [:process.signal/request-changes-for-review signal-opts]]))

(defn- finish-review [review send-to-final-review? signal-opts]
  (cond
    (review-model/final-review? review)
    [[:process.signal/finish-final-review-and-change-state signal-opts]
     [:process.signal/finish-final-review signal-opts]]

    send-to-final-review?
    [[:process.signal/finish-review-to-final signal-opts]]

    :else
    [[:process.signal/finish-review-and-change-state signal-opts]
     [:process.signal/finish-review signal-opts]]))

(defn- completion-signal-options [review review-result send-to-final-review? signal-opts]
  (if (= :review.status/changes-requested review-result)
    (request-change review send-to-final-review? signal-opts)
    (finish-review review send-to-final-review? signal-opts)))

(defn actions-col [tr application-id review-id review-status]
  (when (or (<sub [::review-subs/review-editable? application-id review-id])
            (and (= :review.status/approved review-status)
                 (not= :all-reviews (<sub [::review-subs/review-tab])))
            (<sub [::process/app-signal-permitted? [:process.signal/remove-review (util/mmap review-id)]])
            (<sub [::process/app-signal-permitted? [:process.signal/set-due-date (util/mmap review-id)]]))
    [:div.bx--col.p-0.flex.flex-nowrap.items-center
     (let [sub-review-id     (:db/id (<sub [::review-subs/current-sub-review review-id]))
           draft-assignee    (<sub [::review-subs/assignee review-id])
           draft-group       (<sub [::review-subs/assignment-group review-id])
           due-date          (<sub [::review-subs/due-date review-id])
           review            (<sub [::entities/entity review-id])
           application       (<sub [::entities/entity application-id])
           auth-group        (group-model/get-authority-group application)
           due-date-feature? (and (ff/enabled? :feature-flag.id/review-due-date)
                                  (group-model/has-feature? auth-group :group.feature/review-due-date))
           edit-due-date?    (and due-date-feature?
                                  (-> review :review/review-config :review.config/due-date-enabled?)
                                  (<sub [::process/app-signal-permitted?
                                         [:process.signal/set-due-date (util/mmap review-id)]]))
           menu-actions      (concat
                               (when edit-due-date?
                                 [{:title            (tr [:review/edit-due-date])
                                   :icon             i/calendar
                                   :icon-description (tr [:review/edit-due-date])
                                   :on-click         #(>evt [::review-subs/show-edit-due-date-modal
                                                             review-id due-date])}])
                               (when (<sub [::process/app-signal-permitted? [:process.signal/remove-review (util/mmap review-id)]])
                                 [{:title            (tr [:review/remove])
                                   :icon             i/trash
                                   :icon-description (tr [:review/remove])
                                   :on-click         #(>evt [::review-subs/show-remove-modal review-id])}]))
           begin-signal      [:process.signal/begin-and-create-sub-review (util/mmap review-id)]
           confirm-signal    [:process.signal/confirm-review (-> (util/mmap review-id)
                                                                 (p/assoc-if :review/assignee draft-assignee
                                                                             :review/assigned-to-group draft-group
                                                                             :review/due-date due-date))]
           return-signal     (return-to-in-review-signal review-id sub-review-id)
           new-round-signal  (start-new-review-round-signal review-id)]
       [:<>
        [:div.min-w-0.flex-1.overflow-hidden
         (cond
           (<sub [::process/app-signal-permitted? confirm-signal])
           [review-state-change-button tr application-id confirm-signal (tr [:review/confirm]) nil i/chevron-right]

           (<sub [::process/app-signal-permitted? begin-signal])
           [review-state-change-button tr application-id begin-signal (tr [:review/begin]) nil i/chevron-right
            {:on-click #(>evt [::review-subs/begin-review application-id review-id])}]

           (<sub [::process/app-signal-permitted? new-round-signal])
           [review-state-change-button tr application-id new-round-signal (tr [:review/return]) nil i/chevron-left
            {:on-click #(>evt [::review-subs/show-start-new-round-modal review-id])}]

           (<sub [::process/app-signal-permitted? return-signal])
           [review-state-change-button tr application-id return-signal (tr [:review/return]) (tr [:review/return-confirm])
            i/chevron-left]

           :else
           [:div.mr-auto])]
        [:div.pt-1.ml-auto
         (when (seq menu-actions)
           [ctx-menu/menu
            [{:actions menu-actions}]
            {:data-cy "review-menu-svg"
             :tr      tr}])]])]))

(defn sub-review-data-item [label value]
  [:div.flex.flex-col
   [:span.text-xs.font-bold.pb-1 label]
   [:span value]])

(defn sub-review-display [tr time-tracking? sub-review]
  (let [format-date-time (<sub [::date-util/date-time-fn])]
    [:div.flex.flex-col.flex-grow.pl-3
     [:div.flex.flex-wrap.gap-x-6.gap-y-3
      (when-some [status (:review/status sub-review)]
        [sub-review-data-item
         (tr [:review/status])
         (tr [status])])
      (when time-tracking?
        [sub-review-data-item
         (tr [:review/time-reported])
         (date-util/minutes-to-hour-and-minutes (:sub-review/minutes-spent sub-review))])
      [sub-review-data-item
       (tr [:review/reviewer])
       (user-model/full-name (:sub-review/reviewer sub-review))]
      (when-some [created (:entity/created sub-review)]
        [sub-review-data-item
         (tr [:entity/created])
         (format-date-time created)])
      (when-some [modified (:sub-review/modified-ts sub-review)]
        [sub-review-data-item
         (tr [:updated])
         (format-date-time modified)])]
     [:div.comment.mt-4.flex.flex-col
      [:span.text-xs.font-medium.text-gray-600 (tr [:review/comment])]
      (if-let [comment (not-empty (:sub-review/comment sub-review))]
        [ui-rt/editor-legacy {:initial-value comment
                              :id            (str (:db/id sub-review) "-sub-review-comment")}]
        [:p.italic (tr [:review/no-comment-added-to-review])])]]))

(defn sub-review-display-deprecated [tr time-tracking? sub-review]
  [:div.flex.flex-col.flex-grow.pl-3
   [:div.bx--row.sub-review__status-row.text-xs
    (when (:review/status sub-review)
      [:div.bx--col-xs-4.review-status
       (tr [(:review/status sub-review)])])
    (when time-tracking?
      [:div.bx--col-xs-4.time-reported
       [:span.mr-2 (str (tr [:review/time-reported]))]
       [:span (date-util/minutes-to-hour-and-minutes (:sub-review/minutes-spent sub-review))]])
    [:div.bx--col-xs-4.reviewer
     [user-model/full-name (:sub-review/reviewer sub-review)]]]
   [:div.comment.mt-4
    (if-let [comment (not-empty (:sub-review/comment sub-review))]
      [ui-rt/editor-legacy {:initial-value comment
                            :id            (str (:db/id sub-review) "-sub-review-comment")}]
      [:p.italic (tr [:review/no-comment-added-to-review])])]])

(defn sub-review-comment-list-item [{:keys [tr selected? sub-review on-click modified-ts-enabled?]}]
  [:li.flex.items-center
   (when-let [status (:review/status sub-review)]
     [:span.ml-2.mr-1
      [status-icon status (tr [status])]])
   [ui-text-button/text-button
    {:on-click on-click}
    [(if selected? :span.font-bold :span)
     (let [format-date-time (<sub [::date-util/date-time-fn])
           created          (:entity/created sub-review)
           modified         (:sub-review/modified-ts sub-review)]
       (cond
         (and modified-ts-enabled? modified) (format-date-time modified)
         created (format-date-time created)
         :else (tr [:review/new-comment])))]]])

(defn expanded-review-row-wrapper
  "wrapper for review section contents"
  [& children]
  (into
    [:div.bx--row.mx-4.pt-4]
    children))

(defn review-internal-wrapper
  "wrapper with top border"
  [& children]
  (into
    [:div.bx--row.mx-4.pt-4.mt-4.border-t.border-solid.border-gray-300]
    children))

(defn sub-review-wrapper [sub-review-selection-list review-comment-component]
  [:div.flex.flex-row.w-full
   [:div.flex.w-1-5
    sub-review-selection-list]
   [:div.flex.w-4-5
    review-comment-component]])

;;
;; Review history
;;

(def round-status-indicator
  {:review.status/changes-requested :warning
   :review.status/approved          :ok})


(defn- status-tag [tr status]
  (when status
    [ui-status-tag/tag {:status status}
     (tr (if (= :ok status) [:review/status-ok] [:review/status-needs-changes]))]))


(defn- commenter-name [entity]
  (user-model/full-name (or (:sub-review/reviewer entity)
                            (:entity/creator entity))))


(defn- comment-card [{:keys [tr id title tag text]}]
  [:div.flex.flex-col.gap-2.rounded-md.bg-ui-light-gray.p-4
   [:div.flex.flex-row.items-start.justify-between.gap-4
    [:div.font-semibold title]
    tag]
   (if (not-empty text)
     [ui-rt/editor {:id            id
                    :initial-value text}]
     [:p.italic (tr [:review/no-comment-added-to-review])])])


(defn- review-round-comment-card [tr sub-review]
  [comment-card
   {:tr    tr
    :id    (str (:db/id sub-review) "-review-history-comment")
    :title (tr [:review/commented] [(commenter-name sub-review)])
    :tag   (status-tag tr (round-status-indicator (:review/status sub-review)))
    :text  (:sub-review/comment sub-review)}])


(defmulti acceptance-item-title
  "Element naming the item an item level review comment was given on."
  (fn [_tr acceptance] (-> acceptance :entity/parent :entity/type)))


(defmethod acceptance-item-title :default [_tr _acceptance]
  nil)


(defmethod acceptance-item-title :entity.type/form [_tr acceptance]
  [:span (-> acceptance acceptance-model/acceptance-parent :form/schema :form.schema/name)])


(defmethod acceptance-item-title :entity.type/attachment-version [tr acceptance]
  (let [version-id (-> acceptance :entity/parent :db/id)
        attachment (acceptance-model/acceptance-parent acceptance)
        filename   (:attachment.version.file/filename
                     (<sub [::attachment-subs/latest-file-for-version version-id]))]
    [ui-text-button/text-button
     {:on-click   #(>evt [::attachment-modals/preview-clicked (:db/id attachment) version-id])
      :aria-label (tr [:attachment/open-preview])
      :data-cy    "review-history-attachment-link"}
     (->> [(attachment-model/attachment-title (<sub [:language]) attachment) filename]
          (keep str-util/blank->nil)
          (str/join " "))]))


(defn- acceptance-comment-card [tr acceptance]
  [comment-card
   {:tr    tr
    :id    (str (:db/id acceptance) "-review-history-comment")
    :title [:span.flex.flex-wrap.items-baseline.gap-1
            (tr [:review/commented-on] [(commenter-name acceptance)])
            [acceptance-item-title tr acceptance]
            ":"]
    :tag   (when (:acceptance/value acceptance)
             (status-tag tr (if (= :acceptance.value/ok (:acceptance/value acceptance)) :ok :warning)))
    :text  (:acceptance/text acceptance)}])


(defn- acceptance-comment-section [tr heading acceptances]
  (when (seq acceptances)
    [:div.flex.flex-col.gap-2
     [:h4.text-sm.font-semibold heading]
     (for-all [acceptance acceptances]
       ^{:key (:db/id acceptance)}
       [acceptance-comment-card tr acceptance])]))


(defn- review-round-list-item [{:keys [tr selected? sub-review on-click]}]
  (let [format-date-time (<sub [::date-util/date-time-fn])]
    [:li
     [ui-text-button/text-button
      {:on-click on-click}
      [(if selected? :span.font-bold :span)
       (if-some [timestamp (or (:sub-review/modified-ts sub-review)
                               (:entity/created sub-review))]
         (format-date-time timestamp)
         (tr [:review/new-comment]))]]]))


(defn review-history
  "Review comments grouped by review round, optionally expanded with item level comments.
   `sub-reviews` are expected to be ordered from the newest to the oldest."
  [{:keys [tr review sub-reviews active-comments-only?]}]
  (when (seq sub-reviews)
    (let [review-id           (:db/id review)
          selected-sub-review (<sub [::review-subs/selected-sub-review review-id])
          shown-sub-review    (or selected-sub-review (first sub-reviews))
          show-all-comments?  (<sub [::review-subs/show-all-comments? review-id])
          acceptances         (<sub [::review-subs/sub-review-acceptances
                                     (:db/id shown-sub-review)
                                     active-comments-only?])
          format-date-time    (<sub [::date-util/date-time-fn])]
      [:div.flex.flex-col.gap-3.w-full
       [:h2.text-base.font-semibold (tr [:review/review-history])]
       [:div.flex.flex-col.lg:flex-row.w-full.gap-4.lg:gap-6.border-l-4
        {:class (ui-status/status->border-color-class
                  (get status-indicator (:review/status shown-sub-review) :inactive))}
        [:ul.flex.flex-col.gap-1.flex-none.w-full.lg:w-48.border-b.lg:border-b-0.lg:border-r.border-solid.border-gray-300
         (for-all [sub-review sub-reviews]
           ^{:key (:db/id sub-review)}
           [review-round-list-item
            (util/mmap {:selected? (= (:db/id sub-review) (:db/id shown-sub-review))
                        :on-click  #(>evt [::review-subs/selected-sub-review review-id sub-review])}
                       tr sub-review)])]
        [:div.flex.flex-col.gap-3.flex-none.w-full.lg:w-48
         (when-some [created (:entity/created shown-sub-review)]
           [sub-review-data-item (tr [:entity/created]) (format-date-time created)])
         (when-some [modified (:sub-review/modified-ts shown-sub-review)]
           [sub-review-data-item (tr [:updated]) (format-date-time modified)])]
        [:div.flex.flex-col.gap-4.flex-grow.min-w-0
         [:h4.text-sm.font-semibold (tr [:review/comments])]
         [review-round-comment-card tr shown-sub-review]
         (when show-all-comments?
           [:<>
            [acceptance-comment-section tr (tr [:review/form-comments])
             (get acceptances :entity.type/form)]
            [acceptance-comment-section tr (tr [:review/attachment-comments])
             (get acceptances :entity.type/attachment-version)]])
         (when (seq acceptances)
           [:div
            [ui-text-button/text-button
             {:on-click #(>evt [::review-subs/toggle-all-comments review-id])
              :data-cy  "toggle-all-review-comments"}
             (tr (if show-all-comments?
                   [:review/hide-comments]
                   [:review/show-all-comments]))]])]]])))


(defn- expanded-public-review-row [tr review]
  (let [sub-reviews (<sub [::review-subs/published-sub-reviews (:db/id review)])]
    (when (seq sub-reviews)
      [:div.p-4
       [review-history
        {:tr                    tr
         :review                review
         :sub-reviews           sub-reviews
         :active-comments-only? false}]])))


(defn reviews-list-public-expandable
  "Applicant view of the reviews, where each row can be expanded to show the review history."
  [tr reviews]
  (if (<sub [::ff/enabled? :feature-flag.id/review-history])
    [ui-table/modern-responsive-table
     {:id            "application-public-reviews"
      :items         reviews
      :tr            tr
      :get-status    #(get status-indicator (:review/status %) :task)
      :class         "rounded-md"
      :cols          [[:review/review
                       (fn [review] (review-name tr review reviews))
                       {:class "font-bold"}]
                      [:review/status
                       (fn [review] [review-status tr review])
                       {:class "font-bold"}]
                      [:review/reviewer
                       (fn [review] [user-col tr review])]
                      [:review/review-done
                       (fn [review]
                         (when-some [end-date (:review/end review)]
                           [:span.whitespace-nowrap [(<sub [::date-util/date-time-fn]) end-date]]))]]
      :expanded-func (partial expanded-public-review-row tr)
      :on-expand     (fn [id]
                       (>evt [::review-subs/clear-review-data (js/parseInt id)]))}]
    [reviews-list-public tr reviews]))

(defn assignee-dropdown [{:keys [id tr application assignee on-change label-text assignees]}]
  (let [assignees            (or assignees
                                 (<sub [::review-subs/group-reviewers (-> application :entity/parent :domain/authority-group)]))
        session-user         (<sub [:session/user])
        allowed-to-reassign? (or (= id "new-review")
                                 (<sub [::process/signal-permitted?
                                        (:db/id application)
                                        [:process.signal/reassign-review {:review-id id}]]))]
    (cond
      (<sub [:comm/command-processing? :group/review-users])
      [:div.w-48 (cc/select-skeleton)]

      (seq assignees)
      (into
        [cc/select
         {:id         (str "assignee-" id)
          :class-name "full-width-select"
          :data-cy    "select-reviewer"
          :hide-label (nil? label-text)
          :label-text (or label-text "")
          :value      (or (:db/id assignee) assignee :none)
          :on-change  on-change
          :disabled   (not allowed-to-reassign?)}]
        (concat
          [[cc/select-item
            {:text  (tr [:review/unassigned])
             :value ""}]]
          (for [assignee assignees]
            [cc/select-item
             {:text  (str (user-model/full-name assignee)
                          (when (= (:db/id assignee) (:db/id session-user))
                            (str " " (tr [:assign-to-me]))))
              :value (:db/id assignee)}])))

      :else
      [:div.bold {:data-cy "no-reviewers"} (tr [:review/no-reviewers])])))

(defn review-assignee-field [{:keys [id tr application review on-change label-text assignees]}]
  (if (<sub [::review-subs/review-editable? (:db/id application) id])
    [assignee-dropdown (util/mmap {:assignee (if (<sub [::review-subs/assignee-set? id])
                                               (<sub [::review-subs/assignee id])
                                               (:review/assignee review))}
                                  id tr application label-text on-change assignees)]
    [sub-review-data-item label-text (user-col tr review)]))


(defn assignment-group-dropdown
  [{:keys [id tr application review on-change label-text selected selected-set?]}]
  (let [authority-group-id   (some-> application app-model/workspace :domain/authority-group :db/id)
        groups               (<sub [::review-subs/assignment-groups authority-group-id])
        allowed-to-reassign? (or (= id "new-review")
                                 (<sub [::process/signal-permitted?
                                        (:db/id application)
                                        [:process.signal/reassign-review {:review-id id}]]))
        selected-id          (if selected-set?
                               selected
                               (or selected (-> review :review/assigned-to-group :db/id)))
        selected-group       (p/find-first groups #(= selected-id (:db/id %)))]
    (when (seq groups)
      [ui-select/select
       {:id         (str "assignment-group-" id)
        :class      "full-width-select"
        :data-cy    "select-assignment-group"
        :hide-label (nil? label-text)
        :label-text (or label-text "")
        :value      selected-group
        :values     groups
        :required   false
        :empty-text (tr [:review/unassigned])
        :val->str   :group/name
        :on-change  #(on-change (some-> % :db/id))
        :disabled   (not allowed-to-reassign?)}])))


(defn review-assignment-fields
  "Review assignment-group dropdown. When the review is assigned to a group, the reviewer dropdown
   is limited to that group's members. `on-assignee-change` is provided by the caller so that
   draft vs. persisted assignment handling is preserved."
  [{:keys [tr application review on-assignee-change]}]
  (let [review-id             (:db/id review)
        draft?                (= :review.status/draft (:review/status review))
        auth-group            (group-model/get-authority-group application)
        due-date-auto?        (review-model/automatic-due-date? (:review/review-config review)
                                                                auth-group
                                                                (<sub [::ff/enabled-flags]))
        show-groups?          (and (ff/enabled? :feature-flag.id/review-assignment-groups)
                                   (review-model/not-yet-begun? review))
        assignment-group-set? (<sub [::review-subs/assignment-group-set? review-id])
        assignment-group      (when assignment-group-set?
                                (<sub [::review-subs/assignment-group review-id]))
        selected-group        (if assignment-group-set?
                                assignment-group
                                (-> review :review/assigned-to-group :db/id))
        group                 (or (when selected-group (<sub [::entities/entity selected-group]))
                                  (when-not assignment-group-set?
                                    (:review/assigned-to-group review)))
        member-assignees      (when show-groups?
                                (some-> group group-model/get-users-in-group))
        on-group-change       (fn [group-id]
                                (if (and draft? (not due-date-auto?))
                                  ;; button action confirms review from draft to unreviewed
                                  (>evt [::review-subs/set-assignment-group review-id group-id])
                                  ;; process.signal/reassign-review confirms review immediately
                                  (>evt [::review-subs/reassign-review-to-group application review-id group-id])))]
    [:<>
     (when show-groups?
       [:div.flex.mr-4
        [assignment-group-dropdown (util/mmap {:id            review-id
                                               :label-text    (tr [:review/assignment-group])
                                               :selected      selected-group
                                               :selected-set? assignment-group-set?
                                               :on-change     on-group-change}
                                              tr application review)]])
     [:div.flex.mr-4
      [review-assignee-field (util/mmap {:id         review-id
                                         :label-text (tr [:review/assignee])
                                         :on-change  on-assignee-change
                                         :assignees  member-assignees}
                                        tr application review)]]]))


(defn display-review-content? [{:review/keys [status]}]
  (contains? #{:review.status/in-review :review.status/in-external-mark-up} status))


(defn attachment-details-row [tr id]
  (r/with-let [*selected-version-id (r/atom nil)]
    (let [latest-version-id   (<sub [::attachment-subs/latest-version-id id])
          selected-version-id (or @*selected-version-id latest-version-id)]
      [expanded-review-row-wrapper
       [:div.flex.flex-row.w-full.items-end.justify-between
        [:div.flex
         [attachment-list/version-list (util/mmap id tr *selected-version-id selected-version-id)]
         [attachment-list/version-details (util/mmap id tr selected-version-id)]]
        [attachment-list/open-preview-button (util/mmap id tr selected-version-id)]]])))


(defn item-comments-row [tr application {:db/keys [id] :review/keys [status]}
                         item-id attachment? latest-version-id]
  (let [review-editable?            (<sub [::review-subs/review-editable? (:db/id application) id])
        application-id              (:db/id application)
        acc-parent-id               (if attachment?
                                      latest-version-id
                                      item-id)
        draft-id                    (<sub [::acceptance-subs/draft-id id acc-parent-id])
        attachment-ext?             (and attachment?
                                         (= status :review.status/in-external-mark-up))
        allowed-to-edit-acceptance? (and review-editable?
                                         draft-id
                                         (<sub [::process/signal-permitted? (:db/id application)
                                                [:process.signal/edit-draft-acceptance {:id draft-id}]])
                                         (not attachment-ext?))
        current-comment             (or (<sub [::review-subs/new-item-comment id item-id])
                                        (<sub [::ee/attr-value draft-id :acceptance/text])
                                        (<sub [::acceptance-subs/draft-comment id acc-parent-id]))
        default-content             (if (or draft-id (some? current-comment))
                                      :review/comments-for-this-review
                                      :review/previous-comments)
        selected-content            (cond
                                      (not review-editable?)
                                      (or (<sub [::review-subs/selected-item-comment-content id item-id])
                                          default-content)

                                      allowed-to-edit-acceptance?
                                      (or (<sub [::review-subs/selected-item-comment-content id item-id])
                                          :review/comments-for-this-review)

                                      :else
                                      :review/previous-comments)
        all-acceptances             (if attachment?
                                      (<sub [::attachment-subs/acceptances-for-attachment-versions item-id])
                                      (<sub [::acceptance-subs/acceptance-data-from-newest-to-oldest acc-parent-id]))
        auth-group                  (group-model/get-authority-group application)
        editable-comment?           allowed-to-edit-acceptance?]
    [(if attachment? review-internal-wrapper expanded-review-row-wrapper)
     [:div.flex.flex-col.w-full
      (if (or allowed-to-edit-acceptance? (not review-editable?))
        [ui-cs/content-switcher {:items     comment-switcher-options
                                 :val->str  (comp tr vector)
                                 :current   selected-content
                                 :class     "mb-4"
                                 :on-change #(>evt [::review-subs/change-item-comment-content id item-id %])}]
        [:div.font-bold.text (tr [:review/comments])])
      (case selected-content
        :review/comments-for-this-review
        [:div.flex.flex-col.w-full
         ^{:key (<sub [::review-subs/item-comment-revision id item-id])}
         [ui-rt/editor-legacy
          (merge {:initial-value      current-comment
                  :id                 (str item-id "-item-comment-editor")
                  :authority-group-id (:db/id auth-group)}
                 (when editable-comment?
                   {:on-change #(when-not (= % current-comment)
                                  (>evt [::review-subs/set-new-item-comment
                                         application-id id item-id draft-id %]))
                    :on-blur   #(>evt [::ee/save
                                       application-id
                                       :process.signal/edit-draft-acceptance
                                       draft-id
                                       :acceptance/text
                                       %])}))]]
        :review/previous-comments
        [:div.flex.flex-col
         (for-all [acceptance all-acceptances]
           (let [acceptance-comment (:acceptance/text acceptance)
                 acceptance-id      (:db/id acceptance)
                 comment-details    (str (user-model/full-name (:entity/creator acceptance)) ", "
                                         ((<sub [::date-util/date-time-fn]) (:entity/created acceptance)))]
             [:div.mt-4.pt-4.border-t.border-solid.border-gray-300
              {:key (str acceptance-id "-text-wrapper")}
              [:div.flex.flex-col
               [ui-rt/editor-legacy {:id            (str acceptance-id "-text")
                                     :initial-value acceptance-comment}]
               [:strong comment-details]]]))])]]))


(defn inline-help-box [content]
  [ui/help content {:class "py-0 px-2"}])


(defn item-inputs-row [tr application {:db/keys [id] :review/keys [status]} item-id
                       item attachment? latest-version-id]
  (let [acc-parent-id    (if attachment?
                           latest-version-id
                           item-id)
        application-id   (:db/id application)
        review-editable? (<sub [::review-subs/review-editable? application-id id])
        draft-acc-value  (<sub [::acceptance-subs/draft-value id acc-parent-id])
        draft-id         (<sub [::acceptance-subs/draft-id id acc-parent-id])
        new-acc-value    (or (<sub [::review-subs/review-item-acceptance-value id item-id])
                             draft-acc-value)
        show-inputs?     (not= :review/previous-comments
                               (<sub [::review-subs/selected-item-comment-content id item-id]))
        restricted?      (and attachment?
                              (<sub [::attachment-subs/visibility-restricted? item-id]))
        disabled?        (and attachment?
                              (or (= status :review.status/in-external-mark-up);; Only applies to review-level markup
                                  ;; Disable the control if the item is an attachment and it's locked for editing by someone else
                                  (boolean (<sub [::attachment-subs/locked-for-editing-by item-id]))))]
    (when (and show-inputs? review-editable?)
      [review-internal-wrapper
       [:div.flex.flex-row.w-full.justify-between.items-center
        [:div.flex
         (when (and attachment? review-editable? (not disabled?))
           [att-upload/upload-version-button {:attachment-id item-id
                                              :parent-id     application-id
                                              :markup?       true}])]
        (when-not (<sub [::process/signal-forbidden? application-id [:process.signal/create-acceptance-change-request]])
          [:div.flex.flex-col.items-end
           (if draft-id
             [ui-radio/radio {:name            (str id "-" item-id "-acceptance-radio-buttons")
                              :label-text      (str (tr [(:entity/type item)]) " " (str/lower-case (tr [:review/review-result])))
                              :values          acceptance-model/acceptance-values
                              :disabled-values (when restricted? #{:acceptance.value/needs-changes})
                              :value           (or new-acc-value draft-acc-value)
                              :val->str        (comp tr vector)
                              :on-change       #(>evt [::review-subs/set-review-item-acceptance-value
                                                       application-id id item-id draft-id %])
                              :disabled        (boolean disabled?)}]
             (cc/skeleton-text))
           (when restricted?
             [:div.mt-2.max-w-xs.text-right
              [inline-help-box (tr [:review/restricted-attachment-needs-changes-help])]])])]])))


(defn item-cloudcheck-evidence [application item-id attachment? latest-version-id]
  (->> application
       cloudcheck-model/latest-postcheck-run
       cloudcheck-model/findings
       (mapcat cloudcheck-model/evidence)
       (filter #(if attachment?
                  (and latest-version-id
                       (= latest-version-id
                          (-> % :cloudcheck-finding-evidence/attachment-version-id :db/id)))
                  (= item-id (-> % :cloudcheck-finding-evidence/form-id :db/id))))))

(defn item-cloudcheck-tag [tr application item]
  (let [attachment? (eu/is-type? :entity.type/attachment item)
        item-id     (:db/id item)
        version-id  (when attachment? (<sub [::attachment-subs/latest-non-markup-version-id item-id]))
        evidence    (item-cloudcheck-evidence application item-id attachment? version-id)]
    (when (seq evidence)
      [ui-status-tag/tag {:status :active}
       [:span.inline-flex.items-center.gap-2
        (cc/icon {:icon        i/novacloud
                  :description ""
                  :aria-hidden true
                  :style       {:stroke "currentColor" :stroke-width "1"}
                  :width       "18"})
        (tr [(if (= 1 (count evidence))
               :review/cloudcheck-issue-found
               :review/cloudcheck-issues-found)] [(count evidence)])]])))

(defn cloudcheck-summary-text [tr issue-count item-count]
  (tr [(if (= 1 issue-count)
         (if (= 1 item-count)
           :review/cloudcheck-review-summary-one-issue-one-item
           :review/cloudcheck-review-summary-one-issue)
         (if (= 1 item-count)
           :review/cloudcheck-review-summary-one-item
           :review/cloudcheck-review-summary))]
      [issue-count item-count]))

(defn review-cloudcheck-summary [tr application review]
  (let [items-evidence (->> (concat (:review/forms review) (:review/attachments review))
                            (map (fn [item]
                                   (let [attachment? (eu/is-type? :entity.type/attachment item)
                                         item-id     (:db/id item)
                                         version-id  (when attachment?
                                                       (<sub [::attachment-subs/latest-non-markup-version-id item-id]))]
                                     (item-cloudcheck-evidence application item-id attachment? version-id))))
                            (filter seq))
        evidence-ids   (du/entity-id-set (mapcat identity items-evidence))]
    (when (seq evidence-ids)
      [:div.flex.flex-row.bg-ui-violet-10.rounded.mx-4.mt-2
       [:div.bg-ui-violet-100.rounded-l.flex.items-center.justify-center.px-3.py-4
        (cc/icon {:icon        i/novacloud
                  :description ""
                  :aria-hidden true
                  :style       {:stroke "white" :stroke-width "1.25"}
                  :width       "32"})]
       [:div.flex.flex-row.items-center.justify-start.py-2.px-4
        (cloudcheck-summary-text tr (count evidence-ids) (count items-evidence))]])))

(defn item-cloudcheck-row [tr application review item-id attachment? latest-version-id]
  (r/with-let [*expanded? (r/atom false)]
    (let [evidence       (item-cloudcheck-evidence application item-id attachment? latest-version-id)
          review-id      (:db/id review)
          application-id (:db/id application)
          parent-id      (if attachment? latest-version-id item-id)
          draft-id       (<sub [::acceptance-subs/draft-id review-id parent-id])
          comment        (or (<sub [::review-subs/new-item-comment review-id item-id])
                             (<sub [::ee/attr-value draft-id :acceptance/text])
                             (<sub [::acceptance-subs/draft-comment review-id parent-id]))
          can-add?       (and (= :review.status/in-review (:review/status review))
                              (<sub [::review-subs/review-editable? application-id review-id])
                              draft-id
                              (<sub [::process/signal-permitted? application-id
                                     [:process.signal/edit-draft-acceptance {:id draft-id}]]))]
      (when (seq evidence)
        [:div.mx-4.mt-2
         [ui-card/wrapper {:status :active
                           :class  "!bg-ui-violet-10"}
          [:button.flex.p-4.pl-5.border-0.appearance-none.bg-ui-violet-10.hover:bg-ui-violet-20
           {:on-click #(swap! *expanded? not)}
           [:div.flex.flex-row.items-center.gap-2
            [ui-card/expand-toggle {:expanded? @*expanded?}]
            (cc/icon {:icon        i/novacloud
                      :description ""
                      :aria-hidden true
                      :style       {:stroke "currentColor" :stroke-width "1.25"}
                      :width       "26"})
            [ui-card/title {} (tr [:review/cloudcheck-analysis-results]
                                  [(count evidence)])]]]
          (when @*expanded?
            [ui-card/section {:class "flex flex-col gap-2"}
             (for-frag [evidence-item evidence]
               [ui-card/wrapper {:status :active}
                [ui-card/section {}
                 [:div.flex.flex-col.md:flex-row.items-start.md:items-center.gap-4
                  [:div.flex-1
                   [ui-card/title {}
                    (:cloudcheck-finding-evidence/description evidence-item)]]
                  (when can-add?
                    [ui-blip/blip
                     (fn [show-blip]
                       [ui/button
                        {:kind       :primary
                         :size       :small
                         :on-click   (fn []
                                       (>evt [::review-subs/add-cloudcheck-comment
                                              application-id review-id item-id draft-id comment
                                              (:cloudcheck-finding-evidence/description evidence-item)
                                              (-> evidence-item :entity/parent :cloudcheck-finding/analysis)])
                                       (show-blip (tr [:review/cloudcheck-added])))
                         :class-name "-my-1 -mr-1"}
                        (tr [:review/cloudcheck-add-to-comments])])
                     {:status :success}])]]
                [ui-card/section {}
                 [ui-card/row {}
                  [:div.leading-snug (-> evidence-item :entity/parent :cloudcheck-finding/analysis)]]]])])]]))))

(defn item-details-section [tr review application item]
  (let [attachment?       (eu/is-type? :entity.type/attachment item)
        item-id           (:db/id item)
        latest-version-id (when attachment? (<sub [::attachment-subs/latest-non-markup-version-id item-id]))]
    [:div.flex.flex-col.w-full
     (when attachment?
       [attachment-details-row tr item-id])
     (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
       [item-cloudcheck-row tr application review item-id attachment? latest-version-id])
     [item-comments-row tr application review item-id attachment? latest-version-id]
     [item-inputs-row tr application review item-id item attachment? latest-version-id]]))

(defmulti has-acceptances-with-content? #_{:clj-kondo/ignore [:redundant-fn-wrapper]}
  (fn [entity] (:entity/type entity)))

(defmethod has-acceptances-with-content? :entity.type/form [form]
  (->> form
       acceptance-model/acceptances-for-entity
       (some #(or (:acceptance/value %)
                  (:acceptance/text %)))
       boolean))

(defmethod has-acceptances-with-content? :entity.type/attachment [attachment]
  (->> attachment
       :attachment/versions
       (mapcat acceptance-model/acceptances-for-entity)
       (some #(or (:acceptance/value %)
                  (:acceptance/text %)))
       boolean))

(defmulti entity-has-draft-acceptance? #_{:clj-kondo/ignore [:redundant-fn-wrapper]}
  (fn [entity] (:entity/type entity)))

(defmethod entity-has-draft-acceptance? :entity.type/form [form]
  (->> form
       acceptance-model/acceptances-for-entity
       (some (du/in-state-fn :acceptance.state/draft))
       boolean))

(defmethod entity-has-draft-acceptance? :entity.type/attachment [attachment]
  (->> attachment
       :attachment/versions
       (mapcat acceptance-model/acceptances-for-entity)
       (some (du/in-state-fn :acceptance.state/draft))
       boolean))

(defmethod entity-has-draft-acceptance? :entity.type/party
  [_party]
  false)

(defn form-table-contents [tr {:db/keys [id] :as review} application forms review-editable?]
  (let [ws-id                         (app-model/workspace-id application)
        make-href                     #(href/href :view/form
                                                  {:workspace-id ws-id
                                                   :form-id      (:db/id %)}
                                                  {:review-id id})
        editing?                      (<sub [::review-subs/editing-items? id])
        allowed-to-create-acceptance? (and review-editable?
                                           (<sub [::process/signal-permitted? (:db/id application)
                                                  [:process.signal/create-draft-acceptance]]))]
    {:items         forms
     :get-status    #(let [form-id    (:db/id %)
                           acceptance (<sub [::acceptance-subs/entity-latest-acceptance form-id])]
                       (item-status-indicator acceptance))
     :link          (when-not editing?
                      {:description (tr [:review/open-form])
                       :make-href   make-href})
     :headerless?   true
     :cols          [(when editing?
                       (let [selected-forms (<sub [::review-subs/forms-selected id])]
                         [""
                          (fn [form]
                            (let [form-id (:db/id form)
                                  checked (contains? selected-forms form-id)]
                              (cc/checkbox {:id         (str id "-choose-" form-id "-form-checkbox")
                                            :label-text ""
                                            :hide-label true
                                            :checked    checked
                                            :disabled   (and checked
                                                             (has-acceptances-with-content? form))
                                            :on-change  (fn [check?]
                                                          (let [new-selection (if check?
                                                                                (conj selected-forms form-id)
                                                                                (disj selected-forms form-id))]
                                                            (>evt [::review-subs/update-form-selection id new-selection])))})))
                          {:max-width "50px"}]))
                     [""
                      #(if (ff/enabled? :feature-flag.id/upgraded-sortable-tables)
                         (-> % :form/schema :form.schema/name)
                         (cc/link {:href (make-href %)}
                                  (-> % :form/schema :form.schema/name)))
                      {:flex "2" :max-width "490px"}]
                     (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
                       [""
                        #(vector item-cloudcheck-tag tr application %)
                        {:flex "1"}])
                     [""
                      #(let [form-id       (:db/id %)
                             review-status (get-review-status (<sub [::acceptance-subs/entity-latest-acceptance form-id]))]
                         (tr [review-status]))
                      {:max-width "200px"}]
                     [""
                      #(str ((<sub [::date-util/date-time-fn]) (or (-> % :latest-change :ts)
                                                                   (:entity/created %)))
                            "\n"
                            (when (:latest-change %)
                              (-> % :latest-change :user)))
                      {:max-width  "200px"
                       :class-name "multirow"}]]
     :tr            tr
     :class         "rounded-md"
     :on-expand     (when allowed-to-create-acceptance?
                      (fn [item-id]
                        (>evt [::review-subs/on-item-expand {:item-id        item-id
                                                             :review-id      id
                                                             :application-id (:db/id application)}])))
     :expanded-func (when (and (not editing?) (display-review-content? review))
                      (partial item-details-section tr review application))}))

(defn attachment-table-contents [tr {:db/keys [id] :as review} application attachments review-editable?]
  (let [editing? (<sub [::review-subs/editing-items? id])]
    {:items         attachments
     :get-status    #(let [attachment-id     (:db/id %)
                           latest-version-id (<sub [::attachment-subs/latest-non-markup-version-id attachment-id])
                           acceptance        (<sub [::acceptance-subs/entity-latest-acceptance latest-version-id])]
                       (item-status-indicator acceptance))
     :headerless?   true
     :cols          [(when editing?
                       (let [selected-attachments (<sub [::review-subs/attachments-selected id])]
                         [""
                          (fn [attachment]
                            (let [attachment-id (:db/id attachment)
                                  checked       (contains? selected-attachments attachment-id)
                                  restricted?   (<sub [::attachment-subs/visibility-restricted? attachment-id])]
                              (cc/checkbox {:id         (str id "-choose-" attachment-id "-attachment-checkbox")
                                            :label-text (tr [:review/include-item])
                                            :hide-label true
                                            :checked    checked
                                            :disabled   (or (and checked
                                                                 (has-acceptances-with-content? attachment))
                                                            (boolean (:attachment/locked-for-editing-by attachment))
                                                            (and restricted? (not checked)))
                                            :on-change  (fn [check?]
                                                          (let [new-selection (if check?
                                                                                (conj selected-attachments attachment-id)
                                                                                (disj selected-attachments attachment-id))]
                                                            (>evt [::review-subs/update-attachment-selection id new-selection])))})))
                          {:max-width "50px"}]))
                     [""
                      #(attachment-common/attachment-types-text (<sub [::attachment-subs/attachment-types (:db/id %)]))
                      {:flex "1" :max-width "450px"}]
                     [""
                      (fn [attachment]
                        (when (attachment-list/pdfa-attachment? attachment)
                          [ui/small-pill {:kind :primary} "PDF/A"]))
                      {}]
                     (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
                       [""
                        #(vector item-cloudcheck-tag tr application %)
                        {:flex "1"}])
                     [""
                      #(attachment-list/attachment-filename-column {:id (:db/id %)
                                                                    :tr tr})
                      {:max-width  "200px"
                       :class-name "multirow"}]
                     [""
                      (fn [att]
                        (if (:attachment/locked-for-editing-by att)
                          [:div.flex.items-center
                           (tr [:review/attachment-in-markup])
                           (cc/icon {:icon        i/lock
                                     :description ""
                                     :class-name  "ml-1"})]
                          (let [attachment-id     (:db/id att)
                                latest-version-id (<sub [::attachment-subs/latest-non-markup-version-id attachment-id])
                                ;; Need to first consider review scoped draft-value as primary source, then fallback to latest acceptance for the attachment version if no draft exists,
                                ;; since the draft is what determines the current review status of the item
                                draft-value       (<sub [::acceptance-subs/draft-value id latest-version-id])
                                review-status     (if (some? draft-value)
                                                    (get-review-status {:acceptance/value draft-value})
                                                    (get-review-status (<sub [::acceptance-subs/entity-latest-acceptance latest-version-id])))]
                            (tr [review-status]))))
                      {:max-width "200px"}]
                     [""
                      #(attachment-list/modified-column {:id (:db/id %)})
                      {:class-name "multirow"
                       :max-width  "197px"}]
                     [""
                      #(let [latest-version-id (<sub [::attachment-subs/latest-non-markup-version-id (:db/id %)])]
                         (when (<sub [::attachment-subs/can-preview? latest-version-id])
                           (cc/button {:icon             i/eye
                                       :kind             :primary
                                       :size             :small
                                       :icon-description (tr [:review/preview-attachment])
                                       :class-name       "only-icon-button"
                                       :on-click         (fn []
                                                           (>evt [::attachment-modals/preview-clicked (:db/id %) latest-version-id]))}
                                      "")))
                      {:flex "none"}]]
     :tr            tr
     :class         "rounded-md"
     :on-expand     (fn [item-id]
                      (when (and review-editable?
                                 (<sub [::process/signal-permitted? (:db/id application)
                                        [:process.signal/create-draft-acceptance {:attachment-id item-id
                                                                                  :review-id     id}]]))
                        (>evt [::review-subs/on-item-expand {:item-id        item-id
                                                             :review-id      id
                                                             :application-id (:db/id application)}])))
     :expanded-func (when (and (not editing?) (display-review-content? review))
                      (partial item-details-section tr review application))}))

(defn party-table-contents
  [tr review-id parties]
  (let [editing? (<sub [::review-subs/editing-items? review-id])
        lang     (<sub [:language])]
    {:items       parties
     :headerless? true
     :get-status  (fn [party]
                    (cond
                      (party-model/active? party) :ok
                      (party-model/declined? party) :critical
                      (party-model/pending? party) :warning
                      :else :task))
     :tr          tr
     :class       "rounded-md"
     :cols        [(when editing?
                     (let [selected-ids (<sub [::review-subs/party-ids-selected review-id])]
                       [""
                        (fn [{party-id :db/id}]
                          (cc/checkbox {:id         (str review-id "-choose-" party-id "-party-checkbox")
                                        :label-text (tr [:review/include-item])
                                        :hide-label true
                                        :checked    (contains? selected-ids party-id)
                                        :disabled   false
                                        :on-change  (fn [check?]
                                                      (let [new-selection (if check?
                                                                            (conj selected-ids party-id)
                                                                            (disj selected-ids party-id))]
                                                        (>evt [::review-subs/update-party-selection review-id new-selection])))}))
                        {:max-width "50px"}]))
                   [""
                    (fn [party]
                      (party-model/join-roles-as-string lang party))
                    {}]
                   [""
                    (fn [party]
                      (or (-> (party-model/corporation-and-full-name-or-full-name party lang)
                              str-util/blank->nil)
                          (first (party-model/get-emails party))))
                    {:max-width "432px"}]]}))

(defn requested-attachment-table-contents [tr id requirements app-id review-editable?]
  (let [review-req-ids (<sub [::review-subs/review-requirements id])
        requirements   (->> requirements
                            (filter #(contains? review-req-ids (:db/id %))))]
    {:items       requirements
     :get-status  #(get request-status-indicator (-> % :requirement/border-color keyword) :task)
     :cols        [["" :requirement/title {}]
                   [""
                    #(tr [:review/requested-attachment])
                    {:max-width  "397px"
                     :class-name "multirow"}]
                   (when (and review-editable?
                              (<sub [::process/signal-permitted?
                                     app-id
                                     [:process.signal/remove-requirement-from-review {:requirement-id "signal-test-id"
                                                                                      :review-id      id}]]))
                     [""
                      #(cc/button
                         {:id               (str (:db/id %) "-remove-request-button")
                          :icon             i/remove
                          :kind             :primary
                          :size             :small
                          :icon-description (tr [:review/remove-request])
                          :class-name       "only-icon-button"
                          :on-click         (fn []
                                              (>evt [::req-events/remove-requirement-from-review app-id (:db/id %) id]))}
                         "")
                      {:flex "none"}])]
     :headerless? true
     :tr          tr
     :class       "rounded-md"}))

(defn requested-party-role-table-contents [tr id requirements app-id review-editable?]
  (let [review-req-ids (<sub [::review-subs/review-requirements id])
        requirements   (->> requirements
                            (filter #(contains? review-req-ids (:db/id %))))]
    {:items       requirements
     :get-status  #(get request-status-indicator (-> % :requirement/border-color keyword) :task)
     :cols        [["" :requirement/title {}]
                   [""
                    #(tr [:review/requested-party-role])
                    {:max-width  "397px"
                     :class-name "multirow"}]
                   (when (and review-editable?
                              (<sub [::process/signal-permitted?
                                     app-id
                                     [:process.signal/remove-requirement-from-review {:requirement-id "signal-test-id"
                                                                                      :review-id      id}]]))
                     [""
                      #(cc/button
                         {:id               (str (:db/id %) "-remove-request-button")
                          :icon             i/remove
                          :kind             :primary
                          :size             :small
                          :icon-description (tr [:review/remove-request])
                          :class-name       "only-icon-button"
                          :on-click         (fn []
                                              (>evt [::req-events/remove-requirement-from-review app-id (:db/id %) id]))}
                         "")
                      {:flex "none"}])]
     :headerless? true
     :tr          tr
     :class       "rounded-md"}))

(defn added-items-section [title button table]
  [:div.flex.flex-col.pt-3
   [:div.flex.flex-row.flex-wrap.items-center.justify-between
    [:div.flex
     [:h4 title]]
    (when button
      [:div.flex button])]
   table])


(defn added-forms-section [tr {:db/keys [id] :as review} application review-editable?]
  (let [forms      (<sub [::review-subs/saved-review-forms id])
        auth-group (group-model/get-authority-group application)]
    [added-items-section
     (tr [:review/forms])
     (when (and review-editable?
                (<sub [::process/signal-permitted?
                       (:db/id application)
                       [:process.signal/add-requirement-to-review {:requirement-id "signal-test-id"
                                                                   :review-id      id}]]))
       [add-form/add-button
        {:process-target-id  (:db/id application)
         :authority-group-id (:db/id auth-group)
         :opts               {:id   (str id "-request-forms-button")
                              :kind :tertiary
                              :size :small}
         :button-text        (tr [:review/request-form])
         :add-text           (tr [:review/add-request])
         :cancel-text        (tr [:cancel])
         :review-id          id}])
     [ui-table/modern-responsive-table
      (form-table-contents tr review application forms review-editable?)]]))


(defn request-attachments-modal [tr id application requirements]
  (let [open?            (<sub [::review-subs/request-attachment-modal-open? id])
        close-fn         #(do
                            (>evt [::review-subs/clear-attachment-type-selection id])
                            (>evt [::review-subs/set-request-attachment-modal-open id false]))
        target-id        (:db/id application)
        attachment-types (<sub [::review-subs/attachment-types (:db/id application)])
        selected-type    (<sub [::review-subs/attachment-type-for-request id])
        existing-type-id (->> requirements
                              (map :requirement/attachment-type)
                              (map :db/id)
                              set
                              (filter #(= % (:value selected-type)))
                              first)
        existing-req-id  (->> requirements
                              (filter #(= (-> % :requirement/attachment-type :db/id) existing-type-id))
                              first
                              :db/id)
        add-request-fn   #(do (if (some? existing-req-id)
                                (>evt [::req-events/add-requirement-to-review target-id existing-req-id id])
                                (>evt [::req-events/add-attachment-requirement target-id (:value selected-type) id]))
                              (close-fn))]
    [ui-modal/composed-input-modal
     {:id       (str id "-request-attachment-modal")
      :open     open?
      :on-close close-fn}
     (cc/modal-header {:close-modal close-fn
                       :title       (tr [:review/request-attachment])})
     (cc/modal-body
       {}
       [ui-select/select {:id           (str id "-attachment-requirement-select")
                          :required     true
                          :values       attachment-types
                          :val->str     :text
                          :value        selected-type
                          :allow-empty? false
                          :on-change    #(>evt [::review-subs/select-attachment-type-for-request id %])}])
     (cc/modal-footer
       {}
       (cc/button {:kind     :secondary
                   :on-click close-fn}
                  (tr [:close]))
       (cc/button {:kind     :primary
                   :disabled (nil? selected-type)
                   :on-click add-request-fn}
                  (tr [:review/add-request])))]))


(defn request-party-role-modal
  [tr review-id application-id]
  (let [close-fn         #(do
                            (>evt [::review-subs/clear-party-role-selection review-id])
                            (>evt [::review-subs/set-request-party-role-modal-open review-id false]))
        selected-role    (<sub [::review-subs/party-role-for-request review-id])
        selected-role-id (:value selected-role)
        existing-req-id  (<sub [::party-req-subs/find-requirement-by-party-role application-id selected-role-id])
        add-request-fn   #(do (if (some? existing-req-id)
                                (>evt [::req-events/add-requirement-to-review application-id existing-req-id review-id])
                                (>evt [::req-events/add-party-role-requirement application-id selected-role-id review-id]))
                              (close-fn))]
    [ui-modal/composed-input-modal
     {:id       (str review-id "-request-party-role-modal")
      :open     (<sub [::review-subs/request-party-role-modal-open? review-id])
      :on-close close-fn}
     (cc/modal-header {:close-modal close-fn
                       :title       (tr [:review/request-party-role])})
     (cc/modal-body
       {}
       [ui-select/select {:id           (str review-id "-party-role-requirement-select")
                          :required     true
                          :values       (<sub [::review-subs/unused-party-role-choices application-id])
                          :val->str     :text
                          :value        selected-role
                          :allow-empty? false
                          :on-change    #(>evt [::review-subs/select-party-role-for-request review-id %])}])
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :secondary
          :on-click close-fn}
         (tr [:close]))
       (cc/button
         {:kind     :primary
          :disabled (nil? selected-role)
          :on-click add-request-fn}
         (tr [:review/add-request])))]))

(defn edit-due-date-modal
  [tr application]
  (let [{:keys [review-id value]} (<sub [::review-subs/edit-due-date])
        open?                     (<sub [::review-subs/show-edit-due-date-modal?])
        close-fn                  #(>evt [::review-subs/edit-due-date-modal-cancel-clicked])]
    [ui-modal/composed-input-modal
     {:id         "edit-review-due-date-modal"
      :class-name "modal-overflow-visible"
      :open       open?
      :on-close   close-fn}
     (cc/modal-header {:close-modal close-fn
                       :title       (tr [:review/edit-due-date])})
     (cc/modal-body
       {}
       [ui/date-picker {:tr         tr
                        :id         "edit-review-due-date-input"
                        :label-text (tr [:review/due-date])
                        :fixed?     true
                        :value      value
                        :min-date   (.format date-util/calendar-date-format (date-util/today-end-of-day))
                        :clearable? true
                        :callback   #(>evt [::review-subs/set-edit-due-date %])}])
     (cc/modal-footer
       {}
       (cc/button
         {:kind     :secondary
          :on-click close-fn}
         (tr [:cancel]))
       (cc/button
         {:kind     :primary
          :disabled (and open? (<sub [::review-subs/edit-due-date-unchanged? review-id]))
          :on-click #(>evt [::review-subs/submit-edit-due-date application])}
         (tr [:review/change-due-date])))]))

(defn- selectable-attachment-in-edit-table?
  [selected-attachments attachment]
  (let [attachment-id (:db/id attachment)
        restricted?   (<sub [::attachment-subs/visibility-restricted? attachment-id])]
    (and (not (:attachment/locked-for-editing-by attachment))
         (or (contains? selected-attachments attachment-id)
             (not restricted?)))))

(defn added-attachments-section [tr {:db/keys [id] :review/keys [status] :as review} application requirements
                                 review-editable?]
  (let [attachments                (<sub [::review-subs/saved-review-attachments id])
        ext-tool-name              (<sub [::review-subs/plan-review-tool-name])
        ext-review-signal          [:process.signal/review-open-external-tool {:review-id id}]
        unlock-review-signal       [:process.signal/review-unlock-from-external-tool {:review-id id}]
        unlock-review-permitted?   (<sub [::process/signal-permitted? application unlock-review-signal])
        integration-config-service (<sub [::review-subs/integration-config-service])
        session-id                 (:review/session-id review)
        show-menu-in-markup?       (and unlock-review-permitted?
                                        (= status :review.status/in-external-mark-up)
                                        ext-tool-name)
        review-menu-content        [{:actions [;; we need to show the open Bluebeam session button as long as the review status is in
                                               ;; external mark-up. Session id must be present to open the session.
                                               (when (and show-menu-in-markup?
                                                          session-id)
                                                 {:title            (tr [:review/open-session-from-attachment-review])
                                                  :icon             i/external-link
                                                  :icon-description (tr [:review/open-session-from-attachment-review])
                                                  :on-click         (fn []
                                                                      ;; Note: This "success" event is reused here even though there is no HTTP call.
                                                                      ;; We already have a valid Bluebeam session-id for this review and only need
                                                                      ;; to route it through the same success handler pipeline that normally runs after
                                                                      ;; a real integration-service success. The pipeline:
                                                                      ;;   - expects nil as the error payload (no HTTP request was made), and
                                                                      ;;   - expects a tx-changes style map from which it can extract the session-id
                                                                      ;;     and update the session-confirmation state / open the session modal.
                                                                      ;; The entity db is not updated here; the map shape is only to satisfy the handler.
                                                                      (>evt [::req-events/review-integration-service.success
                                                                             {:entity-id id
                                                                              :provider  :bluebeam}
                                                                             nil
                                                                             {id {:review/session-id [:review/session-id session-id]}}]))})]}
                                    {:actions [(when show-menu-in-markup?
                                                 {:title            (tr [:review/unlock-review-attachments])
                                                  :icon             i/lock-open
                                                  :icon-description (tr [:review/unlock-review-attachments])
                                                  :on-click         #(>evt [::attachment-modals/unlock-clicked id :review])})]}]
        loading?                   (or (<sub [::review-subs/integration-authentication-processing?])
                                       (<sub [::process/signal-processing? :process.signal/review-open-external-tool])
                                       (<sub [::process/signal-processing? :process.signal/review-return-from-external-tool]))
        process-target-id          (:db/id application)]
    [:div.flex.flex-col.w-full
     [attachment-modals/unlock-modal (util/mmap tr process-target-id)]
     [added-items-section
      (tr [:review/attachments])
      [:div.mt-2.flex.flex-wrap.items-center.gap-2
       (when (and (= status :review.status/in-external-mark-up)
                  ext-tool-name)
         [inline-help-box (tr [:review/attachment-external-markup-help]
                              [ext-tool-name])])

       (when (and review-editable?
                  (not (<sub [::process/signal-forbidden? application ext-review-signal]))
                  ext-tool-name)
         (let [errors    (<sub [::review-subs/applicable-errors application ext-review-signal])
               disabled? (not (empty? errors))]
           [:<>
            (when disabled?
              [inline-help-box (->> errors
                                    (map (comp tr vector first))
                                    (str/join " / "))])
            (if loading?
              [:div.w-fit (cc/inline-loading {:description (tr [:file/processing])})]
              (cc/button
                {:id       (str id "-open-external-tool-button")
                 :kind     :tertiary
                 :size     :small
                 :icon     i/external-link
                 :disabled disabled?
                 :on-click (fn []
                             (case integration-config-service
                               :integration-config.service/bluebeam (attachment-list/handle-bluebeam-package
                                                                      {:process-target-id (:db/id application)
                                                                       :entity            review
                                                                       :markup-type       :markup})

                               (do
                                 (>evt [::process/signal
                                        application
                                        [:process.signal/review-open-external-tool {:review-id id}]])
                                 ;; cannot be called in an on-success handler because pop-up blocker may kill it
                                 ;; unfortunately this means that external review tool may open before our
                                 ;; back-end is ready
                                 (-> application
                                     :entity/parent
                                     plan-review-integration-model/review-url
                                     futil/open-in-new-tab-or-window))))}
                [:div.flex.gap-2
                 (tr [:process.signal/review-open-external-tool]
                     [ext-tool-name])]))]))

       (when (and review-editable?
                  (<sub [::process/signal-permitted?
                         application
                         [:process.signal/review-return-from-external-tool {:review-id id}]])
                  ext-tool-name)
         (if loading?
           [:div.w-fit (cc/inline-loading {:description (tr [:file/processing])})]
           (cc/button
             {:id       (str id "-return-from-external-tool-button")
              :kind     :tertiary
              :size     :small
              :on-click (fn []
                          (case integration-config-service
                            :integration-config.service/bluebeam (attachment-list/handle-bluebeam-package
                                                                   {:process-target-id (:db/id application)
                                                                    :entity            review
                                                                    :markup-type       :end-markup})

                            (>evt [::process/signal
                                   application
                                   [:process.signal/review-return-from-external-tool {:review-id id}]])))}
             [:div.flex.gap-2
              (tr [:process.signal/review-return-from-external-tool]
                  [ext-tool-name])])))

       (when (and review-editable?
                  (<sub [::process/signal-permitted?
                         application
                         [:process.signal/add-requirement-to-review {:requirement-id "signal-test-id"
                                                                     :review-id      id}]]))
         (cc/button
           {:id       (str id "-request-attachments-button")
            :kind     :tertiary
            :size     :small
            :on-click #(>evt [::review-subs/set-request-attachment-modal-open id true])}
           (tr [:review/request-attachment])))

       (when (and review-editable?
                  (ctx-menu/has-actions? review-menu-content))
         [ctx-menu/menu
          review-menu-content
          {:data-cy      (str id "-review-attachments-menu")
           :toggle-props {:aria-label (tr [:attachment/actions])}}])]
      [:div.flex.flex-col.w-full
       (when (seq requirements)
         [ui-table/modern-responsive-table
          (requested-attachment-table-contents tr id requirements (:db/id application) review-editable?)])
       (when (seq attachments)
         [ui-table/modern-responsive-table
          (attachment-table-contents tr review application attachments review-editable?)])]]]))


(defn added-party-roles-section
  [tr review-id application-id review-editable?]
  (let [requirements (<sub [::party-req-subs/enriched-party-role-requirements application-id])
        parties      (<sub [::review-subs/saved-review-parties review-id])]
    [:div.flex.flex-col.w-full
     [added-items-section
      (tr [:review/party-roles])
      [:div.flex.space-x-2
       (when (and review-editable?
                  (<sub [::process/signal-permitted?
                         application-id
                         [:process.signal/add-requirement-to-review {:requirement-id "signal-test-id"
                                                                     :review-id      review-id}]]))
         (cc/button
           {:id       (str review-id "-request-party-roles-button")
            :kind     :tertiary
            :size     :small
            :on-click #(>evt [::review-subs/set-request-party-role-modal-open review-id true])}
           (tr [:review/request-party-role])))]
      [:div.flex.flex-col.w-full
       (when (seq requirements)
         [ui-table/modern-responsive-table
          (requested-party-role-table-contents tr review-id requirements application-id review-editable?)])
       (when (seq parties)
         [ui-table/modern-responsive-table
          (party-table-contents tr review-id parties)])]]]))


(defn items-section [tr {:db/keys [id] :as review} application]
  (when (<sub [::review-subs/items-section-visible? id])
    (let [attachment-requirements (<sub [::req-subs/all-attachment-requirements (:db/id application)])
          review-editable?        (<sub [::review-subs/review-editable? (:db/id application) id])]
      [review-internal-wrapper
       (when (and review-editable?
                  (<sub [::review-subs/request-attachment-modal-open? id]))
         [request-attachments-modal tr id application attachment-requirements])
       (when (and review-editable?
                  (<sub [::review-subs/request-party-role-modal-open? id]))
         [request-party-role-modal tr id (:db/id application)])
       [:div.flex.flex-row.w-full.items-center.justify-between.flex-wrap
        [:div.flex.w-2-4.mb-3
         [:h3.mb-0 (tr [:review/items-included])]]
        (when (or (seq (<sub [::review-subs/saved-form-ids id]))
                  (seq (<sub [::review-subs/saved-attachment-ids id])))
          [:div.flex.w-2-4.flex-wrap.justify-end
           (when review-editable?
             (cc/button
               {:id         (str id "-edit-items-button")
                :kind       :ghost
                :size       :small
                :class-name "mr-3 mb-3"
                :icon       i/pen
                :on-click   #(>evt [::review-subs/toggle-editing-items id true])}
               (tr [:review/edit-items])))
           [ui-cs/content-switcher {:items     review-subs/item-visibility-options
                                    :val->str  (comp tr vector)
                                    :class     "mb-3"
                                    :current   (<sub [::review-subs/review-item-visibility id])
                                    :on-change #(>evt [::review-subs/set-review-item-visibility id %])}]])]
       [:div.w-full
        [:div.flex.flex-col
         [added-forms-section tr review application review-editable?]
         [added-attachments-section tr review application attachment-requirements review-editable?]
         [added-party-roles-section tr id (:db/id application) review-editable?]]]])))


(defn select-all-checkbox [{:keys [checkbox-id entities selected-ids on-change label-text]}]
  (let [all-ids      (du/entity-id-set entities)
        ;; entities to keep selected after deselect-all button press
        min-forms    (->> entities
                          (filter entity-has-draft-acceptance?)
                          du/entity-id-set)
        all-checked? (= selected-ids all-ids)]
    [:div.flex
     (cc/checkbox {:id         (str "select-all-checkbox-" checkbox-id)
                   :label-text label-text
                   :checked    all-checked?
                   :disabled   (= min-forms all-ids)
                   :on-change  #(on-change (if all-checked? min-forms all-ids))})]))


(defn forms-edit-table [tr {:db/keys [id] :as review} application review-editable?]
  (when (<sub [::form-subs/has-forms? application])
    (let [forms (<sub [::review-subs/reviewable-forms application])]
      [:div.flex.flex-col
       [select-all-checkbox {:entities     forms
                             :checkbox-id  "forms"
                             :label-text   (tr [:review/forms])
                             :on-change    #(>evt [::review-subs/update-form-selection id %])
                             :selected-ids (<sub [::review-subs/forms-selected id])}]
       [ui-table/modern-responsive-table
        (form-table-contents tr review application forms review-editable?)]])))


(defn attachments-edit-table [tr {:db/keys [id] :as review} application review-editable?]
  (when (<sub [::attachment-subs/has-attachments? (:db/id application)])
    (let [attachments            (<sub [::attachment-subs/attachments-for-parent (:db/id application)])
          selected-attachments   (<sub [::review-subs/attachments-selected id])
          restricted-items?      (seq (<sub [::attachment-subs/restricted-attachment-ids-for-parent (:db/id application)]))
          selectable-attachments (filter (partial selectable-attachment-in-edit-table? selected-attachments)
                                         attachments)]
      [:div.flex.flex-col
       (when restricted-items?
         [inline-help-box (tr [:review/restricted-attachments-help])])
       [select-all-checkbox {:entities     selectable-attachments
                             :checkbox-id  "attachments"
                             :label-text   (tr [:review/attachments])
                             :on-change    #(>evt [::review-subs/update-attachment-selection id %])
                             :selected-ids selected-attachments}]
       [ui-table/modern-responsive-table
        (attachment-table-contents tr review application attachments review-editable?)]])))

(defn parties-edit-table
  [tr review-id application-id]
  (when-let [parties (seq (<sub [::party-subs/parties application-id]))]
    [:div.flex.flex-col
     [select-all-checkbox {:entities     parties
                           :checkbox-id  "parties"
                           :label-text   (tr [:review/parties])
                           :on-change    #(>evt [::review-subs/update-party-selection review-id %])
                           :selected-ids (<sub [::review-subs/party-ids-selected review-id])}]
     [ui-table/modern-responsive-table
      (party-table-contents tr review-id parties)]]))

(defn items-edit-section [tr {:db/keys [id] :as review} application sub-review-id]
  (let [review-editable?     (<sub [::review-subs/review-editable? (:db/id application) id])
        editing-items?       (<sub [::review-subs/editing-items? id])
        selected-forms       (<sub [::review-subs/forms-selected id])
        selected-attachments (<sub [::review-subs/attachments-selected id])
        edit-items-signal    (<sub [::review-subs/edit-items-signal (:db/id application) id])
        changes?             (<sub [::review-subs/changes-for-selected-items? id])
        table-section        (if (ff/enabled? :feature-flag.id/upgraded-sortable-tables)
                               :section.rounded.w-full
                               :section.bg-ui-light-gray.rounded.w-full)]
    (when review-editable?
      [review-internal-wrapper
       (when (<sub [::review-subs/show-initial-add-items-button? id])
         (cc/button
           {:id       (str id "-add-items-button")
            :kind     :ghost
            :icon     i/plus
            :on-click #(>evt [::review-subs/toggle-editing-items id true])}
           (tr [:review/include-items])))
       (when editing-items?
         [table-section
          [:div.flex.flex-col
           [forms-edit-table tr review application review-editable?]
           [attachments-edit-table tr review application review-editable?]
           [parties-edit-table tr id (:db/id application)]
           [:div.flex.flex-row
            (cc/button
              {:id         (str id "-cancel-item-add-button")
               :kind       :tertiary
               :icon       i/remove
               :class-name "mr-4"
               :on-click   #(>evt [::review-subs/toggle-editing-items id false])}
              (tr [:review/cancel]))
            (cc/button
              {:id       (str id "-save-item-changes-button")
               :kind     :primary
               :icon     i/save
               :disabled (not changes?)
               :on-click #(>evt [::review-subs/save-item-changes edit-items-signal application id sub-review-id
                                 selected-forms selected-attachments])}
              (tr [:review/save-changes]))]]])])))

(defn inactive-review [tr id time-tracking? review sub-reviews]
  (let [first-sub-review     (first sub-reviews)
        selected-sub-review  (<sub [::review-subs/selected-sub-review id])
        shown-sub-review     (or selected-sub-review first-sub-review)
        modified-ts-enabled? (<sub [::ff/enabled? :feature-flag.id/sub-review-modified-ts])]
    [:<>
     (when (:review/end review)
       [expanded-review-row-wrapper
        [:div.bx--col-xs-12.font-bold
         (tr [:review/review-was-marked-complete]
             [((<sub [::date-util/date-time-fn]) (:review/end review)) (user-model/full-name (:sub-review/reviewer first-sub-review))])]])
     [:div.bx--col-xs-12.mt-4.pt-4
      (when-not (ff/enabled? :feature-flag.id/upgraded-sortable-tables)
        {:class "border-t border-solid border-gray-300"})
      (if (<sub [::ff/enabled? :feature-flag.id/review-history])
        [review-history (util/mmap tr review sub-reviews)]
        [:<>
         [:h3.text-base.font-semibold.my-2 (tr [:review/comments])]
         [sub-review-wrapper
          [:ul
           (for-all [sub-review sub-reviews
                     :let [selected-sub-review? (if (nil? selected-sub-review)
                                                  (= (:db/id sub-review) (-> (first sub-reviews) :db/id))
                                                  (= (:db/id sub-review) (:db/id selected-sub-review)))]]
             ^{:key (:db/id sub-review)}
             [sub-review-comment-list-item
              (util/mmap {:on-click  #(>evt [::review-subs/selected-sub-review id sub-review])
                          :selected? selected-sub-review?}
                         tr sub-review modified-ts-enabled?)])]
          (if modified-ts-enabled?
            [sub-review-display tr time-tracking? shown-sub-review]
            [sub-review-display-deprecated tr time-tracking? shown-sub-review])]])]]))

(defn add-time-button [{:keys [review-id review-time time]}]
  [:div
   (cc/button
     {:on-click #(>evt [::review-subs/review-time review-id (+ time review-time)])
      :kind     :ghost}
     (str "+" time))])

(defn- due-date-display [tr format-date review auth-group]
  (let [due-date       (:review/due-date review)
        group-tz       (group-model/get-timezone auth-group)
        tz-info        (date-util/time-zone-info group-tz "short" true)
        remaining-days (review-model/remaining-due-days review auth-group (js/Date.))]
    [:div.flex.mr-4
     [:div
      [:label.bx--label (tr [:review/due-date])]
      [:div.flex.my-3.mr-3 (format-date (date-util/to-tz due-date group-tz)) (when tz-info (str " " tz-info))]]
     (when (and remaining-days (not (neg? remaining-days)))
       [:div
        [:label.bx--label (tr [:review/remaining-due-days])]
        [:div.flex.my-3.mr-3 remaining-days]])]))

(defn- complete-button [tr review application review-id sub-review-id review-time review-comment review-result completion-signal can-complete?]
  (let [icon (if (= :review.status/changes-requested review-result)
               i/rotate-left
               i/check)]
    (cc/button
      {:on-click #(>evt [::review-subs/send-review-signal
                         (first completion-signal)
                         application
                         review-id
                         sub-review-id
                         review-time
                         review-comment])
       :disabled (not can-complete?)
       :icon     icon}
      (tr [(complete-button-label-key review review-result)]))))

(defn in-progress-review [{:keys [review
                                  tr
                                  application
                                  on-assignee-change
                                  time-tracking?
                                  sub-reviews]}]
  (let [auth-group                  (group-model/get-authority-group application)
        review-id                   (:db/id review)
        application-id              (:db/id application)
        display-content?            (display-review-content? review)
        draft?                      (-> review :review/status (= :review.status/draft))
        in-review?                  (-> review :review/status (= :review.status/in-review))
        changes-requested?          (-> review :review/status (= :review.status/changes-requested))
        review-result               (<sub [::review-subs/review-result application-id review-id])
        review-time                 (or (<sub [::review-subs/review-time review-id])
                                        (when time-tracking? 0))
        latest-sub-review           (first sub-reviews)
        sub-review-id               (:db/id latest-sub-review)
        review-comment              (or (<sub [::review-subs/review-comment review-id])
                                        (when (some? latest-sub-review)
                                          (:sub-review/comment latest-sub-review))
                                        "")
        review-editable?            (<sub [::review-subs/review-editable? application-id review-id])
        review-config               (-> review :review/review-config)
        feature-flags               (<sub [::ff/enabled-flags])
        due-date-enabled?           (review-model/due-date-enabled? review-config auth-group feature-flags)
        manual-due?                 (review-model/manual-due-date? review-config auth-group feature-flags)
        automatic-due?              (review-model/automatic-due-date? review-config auth-group feature-flags)
        format-date                 (<sub [::date-util/date-fn])
        new-due-date                (when manual-due?
                                      (<sub [::review-subs/due-date review-id]))
        confirm-review-signal       [:process.signal/confirm-review
                                     (p/assoc-if (util/mmap review-id)
                                                 :review/due-date new-due-date)]
        return-signal               (return-to-in-review-signal review-id sub-review-id)
        new-round-signal            (start-new-review-round-signal review-id)
        send-to-final-review?       (and (ff/enabled? :feature-flag.id/final-review)
                                         (not (review-model/final-review? review))
                                         (review-model/linked-to-incomplete-final-review? review))
        complete-signal-opts        (-> (util/mmap review-id)
                                        (p/assoc-if :sub-review-id sub-review-id)
                                        (p/assoc-if :sub-review/minutes-spent review-time))
        completion-signal-options   (completion-signal-options review
                                                               review-result
                                                               send-to-final-review?
                                                               complete-signal-opts)
        permitted-completion-signal (some (fn [signal]
                                            (when (<sub [::process/signal-permitted?
                                                         (:db/id application)
                                                         signal])
                                              signal))
                                          completion-signal-options)
        completion-error-signal     (some (fn [signal]
                                            (when-not (<sub [::process/signal-forbidden?
                                                             (:db/id application)
                                                             signal])
                                              signal))
                                          completion-signal-options)
        complete-signal             permitted-completion-signal
        proceed-signal              (if draft? confirm-review-signal completion-error-signal)
        can-complete?               (some? permitted-completion-signal)
        available-results           (<sub [::review-subs/available-review-results application-id review-id])
        selected-content            (or (<sub [::review-subs/selected-review-comment-content review-id])
                                        :review/comments-for-this-review)]
    [:<>
     [expanded-review-row-wrapper
      [:div.flex.flex-col.lg:flex-row.w-full
       [:div.flex.mb-4.lg:mb-0
        [review-assignment-fields (util/mmap tr application review on-assignee-change)]]
       (when due-date-enabled?
         (if (and manual-due?
                  draft?
                  review-editable?)
           [:div
            [ui/date-picker {:tr         tr
                             :id         "edit-review-due-date"
                             :label-text (str (tr [:review/due-date]) " (" (tr [:optional]) ")")
                             :value      (<sub [::review-subs/due-date review-id])
                             :clearable? true
                             :min-date   (.format date-util/calendar-date-format (date-util/today-end-of-day))
                             :callback   #(>evt [::review-subs/set-due-date review-id %])}]]
           (when (:review/due-date review)
             [due-date-display tr format-date review auth-group])))

       [:div.flex.items-end.justify-between.flex-1
        (when (and in-review?
                   review-editable?)
          [:<>
           (when available-results
             [ui-select/select
              {:values       available-results
               :id           (str review-id "-review-result-select")
               :data-cy      "review-result-select"
               :label-text   (tr [:review/review-result])
               :value        review-result
               :required     false
               :allow-empty? false
               :val->str     (comp tr vector)
               :on-change    #(>evt [::review-subs/review-result review-id %])}])
           (and review-result
                [complete-button tr review application review-id sub-review-id review-time
                 review-comment review-result complete-signal can-complete?])])]]

      (when (and draft? (not automatic-due?)) ;; confirm review button can also confirm edited description
        [:div.mt-4.w-full
         [ui/text-area
          {:label-text (str (tr [:description]) " (" (tr [:optional]) ")")
           :value      (or (<sub [::review-subs/description review-id])
                           (:review/description review))
           :on-change  #(>evt [::review-subs/set-description review-id (futil/tval %)])
           :disabled   (not review-editable?)}]])

      (when-let [problems (seq (if changes-requested?
                                 (<sub [::review-subs/applicable-errors-for-signals application-id new-round-signal return-signal])
                                 (<sub [::review-subs/applicable-errors application-id proceed-signal])))]
        [:div.mt-4
         [ui-error-list/signal-error-list tr problems]])]

     (when (and time-tracking?
                display-content?
                review-editable?)
       [:div.bx--row.mx-4.mt-4.pt-4.flex.items-end
        [:div
         [ui/number-input {:id         (str review-id "-review-time-spent")
                           :label-text (tr [:review/time-used-in-min])
                           :required   true
                           :step       15
                           :min        0
                           :value      review-time
                           :on-change  #(>evt [::review-subs/review-time review-id (-> % futil/tval futil/parse-int)])}]]
        [add-time-button (util/mmap {:time 15} review-id review-time)]
        [add-time-button (util/mmap {:time 60} review-id review-time)]])

     (when display-content?
       [:<>
        [review-internal-wrapper
         [:div.flex.flex-col.w-full
          [ui-cs/content-switcher {:items     comment-switcher-options
                                   :val->str  (comp tr vector)
                                   :current   selected-content
                                   :class     "mb-4"
                                   :on-change #(when review-editable?
                                                 (>evt [::review-subs/change-review-comment-content review-id %]))}]
          (case selected-content
            :review/comments-for-this-review
            [ui-rt/editor-legacy
             (merge {:initial-value      review-comment
                     :id                 (str review-id "-comment-editor")
                     :authority-group-id (:db/id auth-group)}
                    (when review-editable?
                      {:on-change #(>evt [::review-subs/set-review-comment review-id %])
                       :on-blur   (when-let [sub-review-id (:db/id latest-sub-review)]
                                    #(>evt [::ee/save
                                            application-id
                                            :process.signal/save-review-draft-comment
                                            sub-review-id
                                            :sub-review/comment
                                            %]))}))]
            :review/previous-comments
            [:div.flex.flex-col
             (for-all [sub-review sub-reviews]
               (let [sub-review-comment (:sub-review/comment sub-review)
                     sub-review-id      (:db/id sub-review)
                     comment-details    (str (commenter-name sub-review) ", "
                                             ((<sub [::date-util/date-time-fn]) (:entity/created sub-review)))]
                 [review-internal-wrapper {:key (str sub-review-id "-text-wrapper")}
                  [:div.flex.flex-col
                   [ui-rt/editor-legacy {:id            (str sub-review-id "-text")
                                         :initial-value sub-review-comment}]
                   [:strong comment-details]]]))])]]

        [items-section tr review application]
        [items-edit-section tr review application (:db/id latest-sub-review)]])

     (when changes-requested?
       [inactive-review tr review-id time-tracking? review sub-reviews])]))


(defn- final-review-linked-reviews-section
  "Shows the list of reviews linked to a Final Review with their completion status."
  [tr final-review-id]
  (let [linked-reviews (<sub [::review-subs/reviews-linked-to-final final-review-id])
        language       (<sub [:language])]
    (when (seq linked-reviews)
      [:div.mt-4.border-t.border-ui-gray.pt-4
       [:div.mb-4 (tr [:review/final-review-linked-reviews])]
       [:div.flex.flex-col.gap-1
        (for-all [{:review/keys [review-config end] :as review} (->> linked-reviews
                                                                     (sort-by :ordered/order))
                  :let [config-name-style (if end :div.mb-2 :div.font-bold.mb-2)]]
          [:div.flex.gap-2 {:key (:db/id review)}
           (if end
             (cc/icon {:icon        i/check
                       :class-name  "text-status-success"
                       :height      "16px"
                       :description (tr [(:review/status review)])})
             (cc/icon {:icon        i/circle-dash
                       :class-name  "text-ui-gray"
                       :height      "16px"
                       :description (tr [(:review/status review)])}))
           [:div
            [config-name-style
             (review-model/review-config-name review-config language)]

            [:div.mb-4 (tr [:review.config/status]) ": " (tr [(:review/status review)])]]])]])))

(defn expanded-review-row
  [application reviews tr this-review]
  (let [time-tracking?     (<sub [::review-subs/time-tracking?])
        review-id          (:db/id this-review)
        sub-reviews        (<sub [::review-subs/sub-reviews review-id])
        review-end?        (some? (:review/end this-review))
        final-review?      (and (ff/enabled? :feature-flag.id/final-review)
                                (review-model/final-review? this-review))
        auth-group         (group-model/get-authority-group application)
        review-config      (:review/review-config this-review)
        feature-flags      (<sub [::ff/enabled-flags])
        due-date-enabled?  (review-model/due-date-enabled? review-config auth-group feature-flags)
        automatic-due?     (review-model/automatic-due-date? review-config auth-group feature-flags)
        format-date        (<sub [::date-util/date-fn])
        begin-signal       [:process.signal/begin-and-create-sub-review (util/mmap review-id)]
        on-assignee-change (fn [e]
                             (let [value     (-> e futil/tval parse-long)
                                   review-id (:db/id this-review)]
                               ;; In manual mode a draft assignee is staged locally and persisted via the
                               ;; confirm-review step. In auto mode we skip confirm: assigning immediately
                               ;; reassigns (and auto-populates the due date, transitioning to unreviewed).
                               (if (and (= :review.status/draft (:review/status this-review))
                                        (not automatic-due?))
                                 (>evt [::review-subs/set-assignee review-id value])
                                 (>evt [::review-subs/reassign-review application review-id value]))))]
    [:div {:id (review-subs/review-row-id review-id)}
     (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
       [review-cloudcheck-summary tr application this-review])
     (cond
       (= :review.status/unreviewed (:review/status this-review))
       [:<>
        [expanded-review-row-wrapper
         [:div.flex.flex-col
          (when (and (-> this-review :review/review-config :review.config/start-after-previous-finished?)
                     (seq (review-model/previous-unfinished-application-reviews this-review reviews)))
            [:div.font-bold.pb-4.border-b.border-solid.border-ui-gray.w-full
             {:class (ui-status/status->border-color-class
                       (get status-indicator (:review/status this-review) :task))}
             (tr [:review/review-blocked])])
          [:div.flex.flex-col
           [:div.flex.mr-4
            [review-assignment-fields (util/mmap {:review             this-review
                                                  :on-assignee-change on-assignee-change}
                                                 tr application)]]
           (when (and due-date-enabled? (:review/due-date this-review))
             [:div.flex.pt-4
              [due-date-display tr format-date this-review auth-group]])]
          (when final-review?
            [:div [final-review-linked-reviews-section tr review-id]])
          (when-let [problems (seq (<sub [::review-subs/applicable-errors (:db/id application) begin-signal]))]
            [:div.mt-4
             [ui-error-list/signal-error-list tr problems]])]]
        [items-section tr this-review application]
        [items-edit-section tr this-review application nil]]

       review-end?
       [inactive-review tr review-id time-tracking? this-review sub-reviews]

       :else
       [in-progress-review (util/mmap {:review this-review}
                                      tr
                                      application
                                      on-assignee-change
                                      time-tracking?
                                      sub-reviews)])]))


(defn- would-move-out-of-final?
  "Check if reordering would move a review across the Final Review boundary."
  [reviews from-review to-review]
  (let [final-review (some #(when (review-model/final-review? %) %) reviews)
        final-order  (:ordered/order final-review)
        to-order     (:ordered/order to-review)]
    (boolean
      (and final-order
           to-order
           (or (and (review-model/held-review? from-review)
                    (>= to-order final-order))
               (and (review-model/final-review? from-review)
                    (< to-order final-order)
                    ;; The drop target need not be held itself; moving Final Review before any held
                    ;; review resets that review, so confirm whenever it crosses the boundary.
                    (some #(and (review-model/held-review? %)
                                (< (:ordered/order %) final-order)
                                (>= (:ordered/order %) to-order))
                          reviews)))))))

(defn start-new-review-round-modal [tr application-id]
  (when-let [review-id (<sub [::review-subs/start-new-round-review])]
    (let [sub-review-id    (<sub [::review-subs/current-sub-review-id review-id])
          edit-signal      (return-to-in-review-signal review-id sub-review-id)
          new-round-signal (start-new-review-round-signal review-id)
          edit-permitted?  (<sub [::process/app-signal-permitted? edit-signal])
          start-permitted? (<sub [::process/app-signal-permitted? new-round-signal])
          problems         (seq (<sub [::review-subs/applicable-errors-for-signals application-id
                                       new-round-signal edit-signal]))
          close-fn         #(>evt [::review-subs/close-start-new-round-modal])
          edit-fn          #(do (>evt [::process/signal application-id edit-signal])
                                (close-fn))
          start-fn         #(do (>evt [::process/signal application-id new-round-signal])
                                (close-fn))]
      [ui-modal/composed-input-modal
       {:id       "start-new-review-round-modal"
        :open     true
        :on-close close-fn}
       (cc/modal-header {:close-modal close-fn
                         :title       (tr [:review/start-new-round-title])})
       (cc/modal-body {}
                      [:p (tr [:review/start-new-round-body])]
                      (when problems
                        [:div.mt-4
                         [ui-error-list/signal-error-list tr problems]]))
       (cc/modal-footer
         {}
         (cc/button {:kind     :secondary
                     :data-cy  "start-new-round-cancel"
                     :on-click close-fn}
                    (tr [:review/cancel]))
         (cc/button {:kind     :secondary
                     :data-cy  "start-new-round-edit"
                     :disabled (not edit-permitted?)
                     :on-click edit-fn}
                    (tr [:review/return]))
         (cc/button {:kind     :primary
                     :data-cy  "start-new-round-start"
                     :disabled (not start-permitted?)
                     :on-click start-fn}
                    (tr [:review/start-new-round])))])))

(defn reviews-list-authority [{:keys [tr reviews application rearrange?]}]
  (when (not-empty reviews)
    (let [time-tracking?    (<sub [::review-subs/time-tracking?])
          review-to-remove  (<sub [::review-subs/review-to-remove])
          move-out-pending  (<sub [::review-subs/move-out-from-final-review-pending])
          auth-group        (group-model/get-authority-group application)
          due-date-feature? (and (ff/enabled? :feature-flag.id/review-due-date)
                                 (group-model/has-feature? auth-group :group.feature/review-due-date))
          format-date       (<sub [::date-util/date-fn])
          dnd-id            (str "application-authority-reviews-" (:db/id application))
          reset-dnd-order   #(>evt [::dnd/reset-order dnd-id reviews])
          final-with-held?  (and review-to-remove
                                 (not-empty (<sub [::review-subs/held-reviews review-to-remove])))]
      [:<>
       ;; Remove review confirmation modal
       [ui/confirm-modal
        {:open?        (<sub [::review-subs/show-remove-modal?])
         :tr           tr
         :id           "remove-review-modal"
         :modal-title  (tr [:review/remove])
         :on-close     #(>evt [::review-subs/remove-modal-cancel-clicked])
         :on-yes-click #(>evt [::process/signal
                               application
                               [:process.signal/remove-review {:review-id review-to-remove}]])}
        [:<>
         [:p (tr [:review/remove-confirm-text])]
         (when final-with-held?
           [:p.mt-2.text-warning-medium (tr [:review/delete-final-review-warning])])]]

       ;; Move-out confirmation modal - when moving held review after Final Review
       [ui/confirm-modal
        {:open?        (<sub [::review-subs/show-move-out-from-final-review-modal?])
         :tr           tr
         :id           "move-out-modal"
         :modal-title  (tr [:review/move-out-title])
         :on-close     #(do
                          (reset-dnd-order)
                          (>evt [::review-subs/move-out-from-final-review-modal-cancel]))
         :on-yes-click (fn []
                         (>evt [::review-subs/move-out-from-final-review-modal-cancel])
                         (>evt [::process/signal
                                (:application move-out-pending)
                                [:process.signal/reorder-reviews
                                 {:reviews {:from (:from move-out-pending)
                                            :to   (:to move-out-pending)}}]]))}
        (tr [:review/move-out-confirm-text])]
       [edit-due-date-modal tr application]
       [:div
        (when (<sub [::process/signal-processing? :process.signal/reorder-reviews])
          [:div.absolute.bg-ui-light-gray.opacity-50.w-full.h-full.z-10.pt-10.pl-36
           (cc/loading-spinner {:with-overlay false})])

        [ui-table/modern-responsive-table
         {:id                dnd-id
          :items             reviews
          :on-reorder        (when (and rearrange?
                                        (<sub [::process/app-signal-permitted? [:process.signal/reorder-reviews]]))
                               (fn [from to]
                                 (if (would-move-out-of-final? reviews from to)
                                   ;; Show confirmation modal for move-out
                                   (>evt [::review-subs/show-move-out-from-final-review-modal
                                          {:review-id   (:db/id from)
                                           :from        (:db/id from)
                                           :to          (:db/id to)
                                           :application application}])
                                   ;; Normal reorder
                                   (>evt [::process/signal
                                          application
                                          [:process.signal/reorder-reviews
                                           {:reviews {:from (:db/id from)
                                                      :to   (:db/id to)}}]]))))
          :tr                tr
          :get-status        #(get status-indicator (:review/status %) :task)
          :class             "rounded-md"
          :empty-placeholder [:p (tr [:declaration-config.admin/no-configs])]
          :cols              [[:review/review
                               (fn [review] (review-name tr review reviews))
                               {:class "font-bold"}]
                              [:review/status
                               (fn [review] (review-status tr review))
                               {:class "font-bold"}]
                              [:review/assignee
                               (fn [review] [reviewer-col tr review])]
                              (when due-date-feature?
                                [:review/due-date
                                 (fn [review]
                                   (when (-> review :review/review-config :review.config/due-date-enabled?)
                                     (when-let [due-date (<sub [::review-subs/due-date (:db/id review)])]
                                       (format-date
                                         (date-util/to-tz due-date (group-model/get-timezone auth-group))))))])
                              (when time-tracking?
                                [:review/time-used-in-h review-time-used
                                 ;; Though narrow time tracking col spares enough width for enough of button text to fit,
                                 ;;  it is issues-free only if it is the last named column.
                                 ;; Its header wraps well in `en`, but may overflow for other languages to the next column header.
                                 {:width "8%"}])
                              ["" (fn [review]
                                    [actions-col tr (:db/id application) (:db/id review) (:review/status review)])]]
          :expanded-func     (partial expanded-review-row
                                      application
                                      reviews
                                      tr)
          :expanded-row-keys (<sub [::review-subs/expanded-reviews])
          :on-expand         #(>evt [::review-subs/toggle-review-expansion %])}]]])))

(defn new-review-form [_]
  (fn [{:keys [tr application save-event toggle-form-event review-configs]}]
    (let [now                 (js/Date.)
          form-data           (<sub [::review-subs/new-review])
          invalid-form?       (<sub [::review-subs/new-review-form-invalid?])
          language            (<sub [:language])
          allowed-to-comment? (<sub [::process/signal-permitted? (:db/id application) [:process.signal/save-review-draft-comment]])
          auth-group          (group-model/get-authority-group application)
          assignment-groups?  (ff/enabled? :feature-flag.id/review-assignment-groups)
          available-configs   (cond->> (<sub [::review-subs/review-configs (set review-configs)])
                                (->> (review-model/application-reviews-for-current-step application)
                                     (some #(-> % :review/review-config :review.config/final-review?)))
                                (remove :review.config/final-review?))
          selected-config-id  (:review/review-config form-data)
          selected-config     (when selected-config-id (<sub [::entities/entity selected-config-id]))
          selected-group-id   (when assignment-groups?
                                (some-> form-data :review/assigned-to-group futil/parse-int))
          all-assignees       (<sub [::review-subs/group-reviewers auth-group])
          group-assignees     (when selected-group-id
                                (not-empty
                                  (filter #(contains? (du/entity-id-set (:user/groups %)) selected-group-id)
                                          all-assignees)))
          assignees           (if selected-group-id group-assignees all-assignees)
          feature-flags       (<sub [::ff/enabled-flags])
          due-date-enabled?   (review-model/due-date-enabled? selected-config auth-group feature-flags)
          automatic-due?      (review-model/automatic-due-date? selected-config auth-group feature-flags)
          due-date            (get form-data :review/due-date
                                   (review-model/calculate-due-date
                                     form-data
                                     selected-config
                                     auth-group
                                     now))]
      (cc/form
        {:id         "new-review"
         :class-name "bx--row mb-6"}
        [:div.bx--col-xs-12.bx--col-sm-6
         (cc/select
           {:id         "review-type"
            :label-text (tr [:review/review-type])
            :value      (str (get form-data :review/review-config))
            :on-change  #(>evt [::review-subs/update-review-form :review/review-config (-> % futil/tval parse-long)])}
           [ui/placeholder-select-item tr (name :none)]
           (for-frag [review-config available-configs]
             ^{:key (str "review-config-option-" (:db/id review-config))}
             (cc/select-item
               {:text  (review-model/review-config-name review-config language)
                :value (-> review-config :db/id str)})))]
        [:div.bx--col-xs-12.bx--col-sm-6
         [assignee-dropdown {:tr          tr
                             :id          "new-review"
                             :application application
                             :label-text  (tr [:review/select-reviewer])
                             :assignees   assignees
                             :assignee    (get form-data :review/assignee)
                             :on-change   #(>evt [::review-subs/update-review-form :review/assignee (futil/tval %)])}]]
        (when assignment-groups?
          [:div.bx--col-xs-12.bx--col-lg-6.mt-4
           [assignment-group-dropdown {:tr            tr
                                       :id            "new-review"
                                       :application   application
                                       :label-text    (tr [:review/assignment-group])
                                       :selected      (get form-data :review/assigned-to-group)
                                       :selected-set? true
                                       :on-change     #(>evt [::review-subs/update-review-form :review/assigned-to-group %])}]])
        (when due-date-enabled?
          [:div.bx--col-xs-12.bx--col-lg-6.mt-4
           (if automatic-due?
             ;; Auto mode: the due date is computed automatically, show a read-only preview.
             [due-date-display tr
              (<sub [::date-util/date-fn])
              {:review/due-date due-date}
              auth-group]
             [ui/date-picker {:tr         tr
                              :id         "new-review-due-date"
                              :label-text (str (tr [:review/due-date]) " (" (tr [:optional]) ")")
                              :value      due-date
                              :min-date   (.format date-util/calendar-date-format (date-util/today-end-of-day))
                              :clearable? true
                              :callback   #(>evt [::review-subs/update-review-form :review/due-date %])}])])
        [:div.bx--col-xs-12.mt-4
         [ui/text-area
          {:label-text (str (tr [:description]) " (" (tr [:optional]) ")")
           :value      (get form-data :review/description)
           :data-cy    "review-comment"
           :disabled   (not allowed-to-comment?)
           :on-change  #(>evt [::review-subs/update-review-form :review/description (-> % .-target .-value)])}]]
        [:div.bx--col-xs-12.mt-4
         (cc/button
           {:kind             :tertiary
            :class-name       "mr-2"
            :icon             i/remove
            :icon-description (tr [:cancel])
            :on-click         #(>evt [toggle-form-event])}
           (tr [:cancel]))
         (cc/button
           {:kind             :primary
            :data-cy          "save-review-request"
            :icon             i/envelope
            :icon-description (tr [:save])
            :disabled         (boolean invalid-form?)
            :on-click         #(>evt [save-event
                                      (:db/id application)
                                      (-> (p/assoc-if form-data :review/due-date due-date)
                                          (cond-> (not due-date-enabled?)
                                            (dissoc :review/due-date))
                                          (update :review/assignee futil/parse-int)
                                          (update :review/assigned-to-group futil/parse-int))])}
           (tr [:review/save-review-request]))]))))
